/* eslint-disable */
export default {
    en: {
        en: `English`,
        trade_orderbook_sellorbuy: `sell/buy`,
        trade_orderbook_sellorbuy_price: `Price`,
        trade_orderbook_sellorbuy_amount: `Amount`,
        trade_orderbook_sellorbuy_sum: `Sum`,
        trade_orderbook_sell: `Sell`,
        trade_orderbook_sell_price: `Price`,
        trade_orderbook_sell_amount: `Amount`,
        trade_orderbook_sell_sum: `Sum`,
        trade_orderbook_buy: `Buy`,
        trade_orderbook_buy_price: `Price`,
        trade_orderbook_buy_amount: `Amount`,
        trade_orderbook_buy_sum: `Sum`,
        trade_orderbook_decimals: `decimals`,
        trade_markettrades: `Market Trades`,
        trade_markettrades_price: `Price`,
        trade_markettrades_amount: `Amount`,
        trade_markettrades_sum: `Sum`,
        trade_tradezone_limit: `Limit`,
        trade_tradezone_limit_price: `Price`,
        trade_tradezone_limit_amount: `Amount`,
        trade_tradezone_limit_buy: `Buy `,
        trade_tradezone_limit_sell: `Sell`,
        trade_tradezone_market: `Market`,
        trade_tradezone_market_price: `Price`,
        trade_tradezone_market_amount: `Amount`,
        trade_tradezone_market_buy: `Buy`,
        trade_tradezone_market_sell: `Sell`,
        trade_chart_kline: `Kline`,
        trade_chart_depth: `Depth`,
        trade_order_openorder: `Open Order`,
        trade_order_orderhistory: `Order History`,
        trade_order_deals: `Deals`,
        Theamountislessthantheminimum: `The amount is  less than the minimum`,
        trade_order_hideotherpairs: `Hide Other Pairs`,
        trade_amount_is_greater_than_the_balance: `Amount is greater than the balance`,
        trade_cancel_order_success: `Cancel Order Success`,
        trade_the_best_market_pricde: `The best market price`,
        trade_balance_not_enough: `Balance not enough`,
        balance_account_username: `User Name`,
        balance_account_password: `Password`,
        balance_account_repeatpassword: `Repeat Password`,
        balance_account_confirm: `CONFIRM`,
        delete_account: `Logout Account`,       
        delete_account_tips1: `Please note that you are logging out of the account information, please be sure to back up the mnemonic or private key of this account, otherwise you `,
        delete_account_tips2: `will be permanently unable to access this account`,
        delete_account_tips3: `, resulting in loss of assets. The mnemonic and private key can only be manually backed up by you, and the exchange cannot retrieve it. `,
        delete_account_tips4: `After clicking to confirm, enter the password according to the prompt, the system will automatically download a mnemonic file, please save it properly.`,
        delete_account_tips5: `Warning: `,
        delete_account_tips6: `Tips: `,
        delete_account_confirm: `CONFIRM LOGOUT`,
        account_logout: `Logout`,
        account_kyc: `KYC`,
        balance_mnemonics_ihavereadthiswarning: `I have read this warning`,
        balance_mnemonics_complete: `Complete`,
        balance_mnemonics_previous: `PREVIOUS`,
        balance_mnemonics_confirm: `CONFIRM`,
        balance_history: `History`,
        balance_history_deposithistory: `Deposit History`,
        balance_history_deposithistory_time: `Time`,
        balance_history_deposithistory_asset: `Asset`,
        balance_history_deposithistory_amount: `Amount`,
        balance_history_deposithistory_status: `Status`,
        balance_history_deposithistory_action: `Action`,
        balance_history_deposithistory_action_details: `Details`,
        balance_history_withdrawhistory: `Withdraw History`,
        balance_history_withdrawhistory_time: `Time`,
        balance_history_withdrawhistory_asset: `Asset`,
        balance_history_withdrawhistory_amount: `Amount`,
        balance_history_withdrawhistory_status: `Status`,
        balance_history_withdrawhistory_action: `Action`,
        balance_history_withdrawhistory_action_details: `Details`,
        balance_history_transferhistory: `Transfer History`,
        balance_fiat_transferhistory: `Fiat History`,
        balance_history_transferhistory_time: `Time`,
        balance_history_transferhistory_asset: `Asset`,
        balance_history_transferhistory_amount: `Amount`,
        balance_history_transferhistory_status: `Status`,
        balance_history_transferhistory_action: `Action`,
        balance_history_transferhistory_action_details: `Details`,
        balance_view_on_explorer: `view on explorer`,
        balance_balancezone_hide0balance: `Hide 0 balance`,
        balance_balancezone_search: `Search`,
        balance_balancezone_symbol: `Symbol`,
        balance_balancezone_balance: `Balance`,
        balance_balancezone_freeze: `Freeze`,
        balance_balancezone_available: `Available`,
        balance_balancezone_action: `Action`,
        balance_balancezone_transfer: `Transfer`,
        balance_balancezone_transfer_to: `To`,
        balance_balancezone_transfer_receiversaccount: `receiver account`,
        balance_balancezone_transfer_amount: `Amount`,
        balance_balancezone_transfer_typeamount: `type amount`,
        balance_balancezone_transfer_message: `Message`,
        balance_balancezone_transfer_cancel: `Cancel`,
        balance_balancezone_transfer_confirm: `Confirm`,
        balance_balancezone_deposit: `Deposit`,
        balance_balancezone_deposit_copy: `Copy`,
		balance_balancezone_withdraw: `Withdraw`,
		balance_balancezone_fiat_out: `FiatOut`,
        balance_balancezone_withdraw_address: `Address`,
        balance_balancezone_withdraw_inputyourwithdrawaddress: `input your withdraw address`,
        balance_balancezone_withdraw_amount: `Amount`,
        balance_balancezone_withdraw_typeamount: `type amount`,
        balance_balancezone_withdraw_confirm: `Confirm`,
        balance_copy_success: `Copy Success!`,
        balance_please_input_address_and_amount: `Please input address and amount!`,
        balance_successful_withdraw: `Successful withdrawal`,
        orders_ordersrecord_openorders: `Open Orders`,
        balance_withdraw_address: `Withdraw Address`,
        orders_ordersrecord_openorders_time: `Time`,
        orders_ordersrecord_openorders_market: `Market`,
        orders_ordersrecord_openorders_side: `Side`,
        orders_ordersrecord_openorders_price: `Price`,
        orders_ordersrecord_openorders_amount: `Amount`,
        orders_ordersrecord_openorders_total: `Total`,
        orders_ordersrecord_openorders_filled: `Filled%`,
        orders_ordersrecord_openorders_action: `Action`,
        orders_ordersrecord_orderhistory: `Order History`,
        orders_ordersrecord_orderhistory_time: `Time`,
        orders_ordersrecord_orderhistory_market: `Market`,
        orders_ordersrecord_orderhistory_side: `Side`,
        orders_ordersrecord_orderhistory_price: `Price`,
        orders_ordersrecord_orderhistory_amount: `Amount`,
        orders_ordersrecord_orderhistory_total: `Total`,
        orders_ordersrecord_orderhistory_filled: `Filled%`,
        orders_ordersrecord_orderhistory_action: `Action`,
        orders_ordersrecord_deals: `Deals`,
        orders_ordersrecord_deals_time: `Time`,
        orders_ordersrecord_deals_market: `Market`,
        orders_ordersrecord_deals_side: `Side`,
        orders_ordersrecord_deals_price: `Price`,
        orders_ordersrecord_deals_amount: `Amount`,
        orders_ordersrecord_deals_total: `Total`,
        orders_ordersrecord_deals_filled: `Filled%`,
        orders_ordersrecord_deals_action: `Action`,
        nav_trade: `Trade`,
        nav_balance: `Balance`,
        nav_orders: `Orders`,
        nav_faq: `FAQ`,
        nav_fiat: `Fiat`,
        nav_explorer: `Explorer`,
        nav_country_virginia: `Virginia`,
        nav_country_singapore: `Singapore`,
        nav_language_english: `English`,
        nav_create: `Create`,
        nav_create_username: `Username`,
        nav_create_password: `Password`,
        nav_create_repeatpassword: `Repeat Password`,
        nav_create_confirm: `CONFIRM`,
        nav_create_back: `Back`,
        nav_or: `OR`,
        nav_import: `Import`,
        nav_import_bymnemonics: `By mnemonics`,
        nav_import_typeyourmnemonics: `Type your mnemonics`,
        nav_import_entermnemonics: `Enter mnemonics`,
        nav_import_password: `Password`,
        nav_import_enterpassword: `Enter password`,
        nav_import_repeatpassword: `Repeat password`,
        nav_import_reenterpassword: `Re-enter password`,
        nav_import_byprivatekey: `By private key`,
        nav_import_typeyourprivatekey: `Type your Private Key`,
        nav_import_enterprivatekey: `Enter Private Key`,
        nav_import_confirm: `CONFIRM`,
        nav_import_createaccount: `create account`,
        nav_import_back: `Back`,
        account_copy: `Copy`,
        account_view: `View`,
        account_export: `Export`,
        account_export_verifypassword: `Verify Password`,
        account_export_entersomething: `Enter something`,
        account_export_confirm: `CONFIRM`,
        account_switchaccount: `Switch Account`,
		account_createnewaccount: `Create New Account`,
		account_shareinviterlink: `Invitation Link`,
		account_changeinviter: `Change Inviter`,
        account_importaccount: `Import Account`,
        account_createasset: `Create Asset`,
        account_createmarket: `Create Market`,
        account_what_is_mnomenics: `What's Mnomenics?`,
        footer_ecology: `Ecology`,
        footer_ecology_bytetradeblockchain: `Bytetrade Blockchain`,
        footer_ecology_downloadclients: `Download Clients`,
        footer_ecology_pitiopaymentprotocal: `PITIO payment protocal`,
        footer_support: `Support`,
        footer_support_createaccount: `Create Account`,
        footer_support_deposit: `Deposit`,
        footer_support_withdraw: `Withdraw`,
        footer_support_fees: `Fees`,
        footer_support_fee: `Fee`,
        footer_support_more: `More`,
        footer_contact: `Contact`,
        footer_contact_listtoken: `List Token`,
        footer_socialmedia: `Social Media`,
        footer_mediakit_telegram: `Telegram`,
        footer_mediakit_facebook: `Facebook`,
        footer_mediakit_twitter: `Twitter`,
        footer_mediakit_medium: `Medium`,
        trade_high: `High`,
        trade_low: `Low`,
        trade_volume: `Volume`,
        trade_change: `Change`,
        trade_turnover: `Turnover`,
        trade_coin_name: `Coin`,
        trade_set_price_field_to_current_highest_ask: `Set price field to current highest ask`,
        trade_set_price_field_to_current_highest_bid: `Set price field to current highest bid`,
        trade_set_price_field_to_current_low_ask: `Set price field to current lowest ask`,
        trade_set_price_field_to_current_low_bid: `Set price field to current lowest bid`,
        trade_chart: `Chart`,
        trade_order_submitted: `Order Submitted`,
        trade_amount_can_not_be_empty: `amount can not be empty`,
        trade_input_is_invaild: `input is invaild`,
        trade_the_balance_is_not_enough: `The available is not enough`,
        trade_next: `Next`,
        trade_prev: `Prev`,
        trade_no_record: `No Record`,
        trade_amount_is_too_small: `Amount Is Too Small`,
        trade_market_price_error: `Submission failed , because  has no price in the market.`,
        trade_market_price: `Market Price`,
        account_only_3_steps_it_won_t_take_much_longer: `Only 3 steps , it won't take much longer`,
        acccount_important: `Important`,
        account_back_your_account: `Back your account`,
        account_do_not_forge: `DO NOT FORGET`,
        account_to_save_your_mnomenics_you_will_need_this: `to save your mnomenics. You will need this`,
        account_confirm_mnemonic: `Confirm mnemonic`,
        account_fill_in_the_blanks_to_ensure_the_backup_is_correct: `Fill in the blanks to ensure the backup is correct`,
        account_user_name_is_invaild: `User Name is invaild`,
        account_password_not_satisfied: `password don't match`,
        account_i_have_read_this_warning: `I have read this warning`,
        account_byteTrade_is_a_decentralized_system: ` is a decentralized system. If you lose your account information from this computer, we are sorry that we can't retrieve it.`,
        account_do_it_later: `Do it later`,
        account_please_agree_the_anouncement_below: `Please agree the anouncement below`,
        // not trans
        account_welcome_back: `Welcome Back`,
        account_by_mnemonics: `By mnemonics`,
        account_by_private_key: `By private key`,
        account_type_your: `Type your`,
        account_type_mnemonics: `mnemonics`,
        account_enter: `Enter`,
        account_enter_password: `Enter password...`,
        account_repeat_password: `Repeat password`,
        account_re_enter_password: `Re-enter password...`,
        account_or: `OR`,
        account_crete_account: `Create account`,
        account_private_key: `Private Key`,
        account_mnomenics_error: `Mnomenics Error`,
        account_mnemonics_cannot_be_empty: `mnemonics cannot be empty`,
        account_password_cannot_be_empty: `password cannot be empty`,
        account_password_unsame: `password not equal reepat password`,
        account_username_is_already_exist: `username is already exist`,
        account_input_the_password: `input the password`,
        account_mnomenics_was_incorrect: `Mnomenics was incorrect`,
        account_password_wrong: `Password wrong`,
        account_username_not_exist: `This account name dosen't exisit on our blockchain`,
        account_mnemonics_length_error: `mnemonics length error`,
        account_username_already_exist: `username already exist`,
        account_username_invaild: `username invaild`,
        account_password_error: `password error`,
        account_fail_transfer: `fail transfer`,
        balance_estimated_value: `Estimated Value`,
        balance_input_your_message: `input your message here`,
        balance_deposit_address: `Deposit address`,
        balance_deposit_address_new: `New address`,
        balance_deposit_address_legacy: `Legacy address`,
        balance_deposit_address_hint_bch: `BCH has two different formats of address. Both of them can store your coins correctly`,
        balance_deposit_convert: `Convert`,
        balance_deposit_convert_hint: `Some wallet may not support the new address, so click the 'Convert' to change address format.`,
        balance_scan_this_qr_code: `Scan this QR code`,
        balance_please_go_to: `Please go to`,
        balance_view_Progress: `view progress`,
        balance_do_not_deposit_any_non_eth_assets_to_this_address: `Do not deposit any non-{asset} assets to this address`,
        balance_min_deposit_amount: `Min deposit amount:`,
        balance_min_withdraw_amount: `Min withdraw amount`,
        balance_be_sure_to_check_the_security: `Be sure to check the security of your computer and browser to prevent information from being tampered with or leaked`,
        balance_successful_transfer: `successful transfer`,
        balance_please_input_valid_address: `Please input valid {asset} address`,
        order_no_more: `no more`,
        order_this_is_last_page: `this is last page`,
        history_process_time: `Process Time`,
        history_transaction: `Transaction`,
        mainpage_banner_tatle: `Professional, Secure and Transparent Cryptocurrency Trading Platform`,
        mainpage_advantage_title: `The World's Leading Cryptocurrency Decentralized Trading Platform`,
        mainpage_advantage_subtitle: `Provide safe, stable and efficient asset trading services to 1 million global professional cryptocurrency investors `,
        mainpage_advantage_assetsecurity: `Cross-chain Asset Security`,
        mainpage_advantage_assetsecurity_details: `Return to decentralization, the user keep private key by themself, master 100% of fund management rights. Users'assets are locked in smart contracts, multi- signature in all super nodes ensures security.`,
        mainpage_advantage_tradingspeed: `Lightning trading speed`,
        mainpage_advantage_tradingspeed_details: `Complete an order within 3 seconds - the same trading speed as a centralized trading system.Achieve a double leap in performance and security with the advanced consensus mechanism of ByteTrade Blockchain.`,
        mainpage_advantage_crosschain: `Perfect cross-chain mechanism`,
        mainpage_advantage_crosschain_details: `The only true cross-chain solution in the decentralized trading system, supporting BTC、USDT(ERC20)、ETH 、CMT and other mainstream blockchain assets, and will continue to expand the scope.`,
        mainpage_advantage_globalarrangement: `Global arrangement`,
        mainpage_advantage_globalarrangement_details: `Super nodes are deployed in 8 countries on four continents，ensure the ultimate trading experience for users around the world.International team formation, continue to connect with global quality projects.`,
        mainpage_advantage_kline: `Professional K-line indicator tool `,
        mainpage_advantage_kline_details: `Transaction interface returns to centralization experience, easy to use.Support 7*24 hours Professional customer service.`,
        mainpage_latest_price: `Latest price`,
        mainpage_change: `Change`,
        c1: `Tokyo`,
        c2: `Virginia`,
        c3: `London`,
        c4: `Singapore`,
        c5: `Sydney`,
        c6: `Sao Paulo`,
        c7: `California`,
        c8: `Seoul`,
        c9: `Frankfurt`,
        c10: `Ohio`,
        c11: `Oregon`,
        p1: `Tokyo`,
        p2: `Virginia`,
        p3: `London`,
        p4: `Singapore`,
        p5: `Sydney`,
        p6: `Sao Paulo`,
        p7: `California`,
        p8: `Seoul`,
        p9: `Frankfurt`,
        p10: `Ohio`,
        p11: `Oregon`,
        en: `English`,
        password: `Password`,
        confirmpw: `Confirm password`,
        signup: `SIGN UP`,
        alreadysu: `Registered?`,
        login: `LOGIN`,
        signuptitle: `WELCOME TO GATEWAYSTAR`,
        email: `Email`,
        signupwelcome: `WELCOME TO GATEWAYSTAR`,
        confirm: `CONFIRM`,
        forgetpw: `Forget your password`,
        passwordWrong: `Password at least 8 characters and contains English letters and numbers`,
        emailWrong: `Invalid email address`,
        loginWrong: `Wrong emal or password`,
        userExits: `Email already exits`,
        passwordIsSame: `Those passwords didn't match`,
        pleaseInputRightEmail: `Please input right email`,
        success: `Success`,
        invalid_referrer_info: `Invalid Referrer Info`,
        invalid_referrer_info_desc: `This referral account dosen't exsit , please make sure the referral link is correct or complete. Clicking "Continue to create" will not use the referral information to complete the account creation. Are you sure to continue?`,
        invalid_referrer_info_cancel: `Cancel`,
        invalid_referrer_info_create: `Continue to Create`,
        input_the_type_and_account_name: `Input the {type} and account name, separated by spaces`,
        no_more_input_before_exit: `No more input before exit`,
        kyc_function_name: 'KYC',
        kyc_step1_title: 'Step 1',
        kyc_step1_subtitle: 'Verify Information',
        kyc_step2_title: 'Step 2',
        kyc_step2_subtitle: 'Upload Identity Image',
        kyc_step1_field1_title: 'Verify Phone Number',
        kyc_step1_field1_content1: 'Enter your telephone number',
        kyc_step1_field1_content2: '6 Digital Code',
        kyc_step1_field1_content3: 'Send SMS Code',
        kyc_step1_field1_content4: 'Resend',
        kyc_step1_field2_title: 'Verify Email Address',
        kyc_step1_field2_content1: 'Enter your Email Address',
        kyc_step1_field2_content2: '6 Digital Code',
        kyc_step1_field2_content3: 'Send Email',
        kyc_step1_field2_content4: 'Resend',
        kyc_step1_confirm_button: 'CONFIRM',
        kyc_step2_field1_title: 'First Name',
        kyc_step2_field1_content: 'First Name',
        kyc_step2_field2_title: 'Last Name',
        kyc_step2_field2_content: 'Last Name',
        kyc_step2_field3_title: 'Identity Type',
        kyc_step2_field3_content1: 'National ID Card',
        kyc_step2_field3_content2: 'Passport',
        kyc_step2_field3_content3: 'Driving License',
        kyc_step2_field4_title: 'Document Number',
        kyc_step2_field4_content: 'Input the identity number',
        kyc_step2_field5_title: 'Upload Identity Document',
        kyc_step2_field5_subtitle: '* Please make sure the photo and text are clear, otherwise it may affect the review',
        kyc_step2_field5_content1: 'Click to upload front photo of document',
        kyc_step2_field5_content2: 'Click to upload the back photo of document',
        kyc_step2_field5_content3: 'Click to upload a selfie of holding the front of the identity document',
        kyc_step2_field5_content4_1: 'Click to upload a valid proof of address less older than 3 months old',
        kyc_step2_field5_content4_2: 'a. Utility bills (Electricity, Gas, Water, etc.);\nb. Landline phone bill;\nc. Credit card or bank statement',
        kyc_status_processing: 'Your ID information is under review',
        kyc_status_succeed: 'Your ID information has been verified.',
        kyc_status_fail: 'Your identity verification has failed',
        kyc_status_content1: 'Document No.',
        kyc_status_content2: 'Reason',
    },
    zhCN: {
        zhCN: `简体中文`,
        trade_orderbook_sellorbuy: `卖出/买入`,
        trade_orderbook_sellorbuy_price: `价格`,
        trade_orderbook_sellorbuy_amount: `数量`,
        trade_orderbook_sellorbuy_sum: `累计`,
        trade_orderbook_sell: `卖出`,
        trade_orderbook_sell_price: `价格`,
        trade_orderbook_sell_amount: `数量`,
        trade_orderbook_sell_sum: `累计`,
        trade_orderbook_buy: `买入`,
        trade_orderbook_buy_price: `价格`,
        trade_orderbook_buy_amount: `数量`,
        trade_orderbook_buy_sum: `累计`,
        trade_orderbook_decimals: `精度`,
        trade_markettrades: `实时成交`,
        trade_markettrades_price: `价格`,
        trade_markettrades_amount: `数量`,
        trade_markettrades_sum: `累计`,
        trade_tradezone_limit: `限价单`,
        trade_tradezone_limit_price: `价格`,
        trade_tradezone_limit_amount: `数量`,
        trade_tradezone_limit_buy: `买入 `,
        trade_tradezone_limit_sell: `卖出`,
        trade_tradezone_market: `市价单`,
        trade_tradezone_market_price: `价格`,
        trade_tradezone_market_amount: `数量`,
        trade_tradezone_market_buy: `买入`,
        trade_tradezone_market_sell: `卖出`,
        trade_chart_kline: `行情图`,
        trade_chart_depth: `深度图`,
        trade_order_openorder: `当前委托`,
        trade_order_orderhistory: `委托历史`,
        trade_order_deals: `已完成交易`,
        Theamountislessthantheminimum: `金额低于最小提币额`,
        trade_order_hideotherpairs: `隐藏其他交易对`,
        trade_amount_is_greater_than_the_balance: `金额大于余额`,
        trade_balance_not_enough: `余额不足`,
        trade_the_best_market_pricde: `最佳市场价格`,
        balance_account_username: `请输入您的用户名`,
        balance_account_password: `密码设置`,
        balance_account_repeatpassword: `重复密码`,
        balance_account_confirm: `确认账号申请`,
        delete_account: `登出账户`,
        delete_account_tips1: `请注意，您正在登出账户信息，请一定确认已备份此账户的助记词或私钥，否则将`,
        delete_account_tips2: `永久无法访问此账户`,
        delete_account_tips3: `，造成资产损失。助记词与私钥只能经过您手动备份，交易所无法找回。`,
        delete_account_tips4: `点击确认删除后，根据提示输入密码后系统会自动下载一份助记词文件，请妥善保管。`,
        delete_account_tips5: `警告：`,
        delete_account_tips6: `提醒：`,
        delete_account_confirm: `确认登出`,
        account_logout: `登出`,
        account_kyc: `KYC`,
        balance_mnemonics_ihavereadthiswarning: `我已阅读注意事项`,
        balance_mnemonics_complete: `完成`,
        balance_mnemonics_previous: `上一步`,
        balance_mnemonics_confirm: `确认`,
        balance_history: `历史记录`,
        balance_history_deposithistory: `充值记录`,
        balance_fiat_transferhistory: `法币记录`,
        balance_history_deposithistory_time: `日期`,
        balance_history_deposithistory_asset: `资产`,
        balance_history_deposithistory_amount: `数量`,
        balance_history_deposithistory_status: `状态`,
        balance_history_deposithistory_action: `操作`,
        balance_history_deposithistory_action_details: `详情`,
        balance_history_withdrawhistory: `提币记录`,
        balance_history_withdrawhistory_time: `日期`,
        balance_history_withdrawhistory_asset: `资产`,
        balance_history_withdrawhistory_amount: `数量`,
        balance_history_withdrawhistory_status: `状态`,
        balance_history_withdrawhistory_action: `操作`,
        balance_history_withdrawhistory_action_details: `详情`,
        balance_history_transferhistory: `转账记录`,
        balance_history_transferhistory_time: `日期`,
        balance_history_transferhistory_asset: `资产`,
        balance_history_transferhistory_amount: `数量`,
        balance_history_transferhistory_status: `状态`,
        balance_history_transferhistory_action: `操作`,
        balance_history_transferhistory_action_details: `详情`,
        balance_view_on_explorer: `浏览器查看`,
        balance_balancezone_hide0balance: `隐藏0资产`,
        balance_balancezone_search: `搜索`,
        balance_balancezone_symbol: `币种`,
        balance_balancezone_balance: `资产`,
        balance_balancezone_freeze: `委托冻结`,
        balance_balancezone_available: `可用`,
        balance_balancezone_action: `操作`,
        balance_balancezone_transfer: `转账`,
        balance_balancezone_transfer_to: `给`,
        balance_balancezone_transfer_receiversaccount: `接收者账户名`,
        balance_balancezone_transfer_amount: `数量`,
        balance_balancezone_transfer_typeamount: `转账金额`,
        balance_balancezone_transfer_message: `备注留言`,
        balance_balancezone_transfer_cancel: `取消`,
        balance_balancezone_transfer_confirm: `确认`,
        balance_balancezone_deposit: `充值`,
        balance_balancezone_deposit_copy: `复制`,
        balance_balancezone_withdraw: `提现`,
		balance_balancezone_fiat_out: `出售`,
        balance_balancezone_withdraw_address: `提币地址`,
        balance_balancezone_withdraw_inputyourwithdrawaddress: `填写提币地址`,
        balance_balancezone_withdraw_amount: `数量`,
        balance_balancezone_withdraw_typeamount: `提币金额`,
        balance_balancezone_withdraw_confirm: `确认`,
        balance_copy_success: `复制成功!`,
        balance_please_input_address_and_amount: `请填入地址和数量`,
        balance_successful_withdraw: `提现提交成功`,
        balance_successful_transfer: `转账成功`,
        balance_withdraw_address: `提现地址`,
        orders_ordersrecord_openorders: `当前委托`,
        orders_ordersrecord_openorders_time: `日期`,
        orders_ordersrecord_openorders_market: `市场`,
        orders_ordersrecord_openorders_side: `方向`,
        orders_ordersrecord_openorders_price: `价格`,
        orders_ordersrecord_openorders_amount: `数量`,
        orders_ordersrecord_openorders_total: `累计`,
        orders_ordersrecord_openorders_filled: `完成%`,
        orders_ordersrecord_openorders_action: `操作`,
        orders_ordersrecord_orderhistory: `委托历史`,
        orders_ordersrecord_orderhistory_time: `日期`,
        orders_ordersrecord_orderhistory_market: `市场`,
        orders_ordersrecord_orderhistory_side: `方向`,
        orders_ordersrecord_orderhistory_price: `价格`,
        orders_ordersrecord_orderhistory_amount: `数量`,
        orders_ordersrecord_orderhistory_total: `累计`,
        orders_ordersrecord_orderhistory_filled: `完成%`,
        orders_ordersrecord_orderhistory_action: `操作`,
        orders_ordersrecord_deals: `已完成交易`,
        orders_ordersrecord_deals_time: `日期`,
        orders_ordersrecord_deals_market: `市场`,
        orders_ordersrecord_deals_side: `方向`,
        orders_ordersrecord_deals_price: `价格`,
        orders_ordersrecord_deals_amount: `数量`,
        orders_ordersrecord_deals_total: `累计`,
        orders_ordersrecord_deals_filled: `完成%`,
        orders_ordersrecord_deals_action: `操作`,
        nav_trade: `交易`,
        nav_balance: `资产`,
        nav_orders: `订单`,
        nav_faq: `FAQ`,
        nav_fiat: `法币`,
        nav_explorer: `浏览器`,
        nav_country_virginia: `弗吉尼亚`,
        nav_country_singapore: `新加坡`,
        nav_language_english: `英语`,
        nav_create: `创建账户`,
        nav_create_username: `用户名`,
        nav_create_password: `设置密码`,
        nav_create_repeatpassword: `重复密码`,
        nav_create_confirm: `确认`,
        nav_create_back: `返回`,
        nav_or: `或者`,
        nav_import: `导入账户`,
        nav_import_bymnemonics: `根据助记词`,
        nav_import_typeyourmnemonics: `请输入您的助记词`,
        nav_import_entermnemonics: `请输入助记词`,
        nav_import_password: `密码`,
        nav_import_enterpassword: `请输入密码`,
        nav_import_repeatpassword: `请重复密码`,
        nav_import_reenterpassword: `请重复密码`,
        nav_import_byprivatekey: `根据私钥`,
        nav_import_typeyourprivatekey: `请输入您的私钥`,
        nav_import_enterprivatekey: `请输入私钥`,
        nav_import_confirm: `确认`,
        nav_import_createaccount: `创建账户`,
        nav_import_back: `返回`,
        account_copy: `复制`,
        account_view: `查看`,
        account_export: `导出`,
        account_export_verifypassword: `密码验证`,
        account_export_entersomething: `请输入密码`,
        account_export_confirm: `确认`,
        account_switchaccount: `切换账号`,
        account_createnewaccount: `创建新账号`,
        account_importaccount: `导入账号`,
        account_createasset: `创建资产`,
        account_createmarket: `创建市场`,
        account_what_is_mnomenics: `什么是助记词?`,
        footer_ecology: `ByteTrade公链生态`,
        footer_ecology_bytetradeblockchain: `ByteTrade公链`,
        footer_ecology_downloadclients: `下载客户端`,
        footer_ecology_pitiopaymentprotocal: `PiTIO 支付协议`,
        footer_support: `支持`,
        footer_support_createaccount: `创建账号`,
        footer_support_deposit: `充值`,
        footer_support_withdraw: `提币`,
        footer_support_fees: `费率`,
        footer_support_fee: `手续费`,
        footer_support_more: `更多`,
        footer_contact: `联系我们`,
        footer_contact_listtoken: `上币申请`,
        footer_socialmedia: `社交媒体`,
        footer_mediakit_telegram: `电报`,
        footer_mediakit_facebook: `Facebook`,
        footer_mediakit_twitter: `推特`,
        footer_mediakit_medium: `Medium`,
        trade_high: `最高价`,
        trade_low: `最低价`,
        trade_volume: `成交量`,
        trade_turnover: `成交额`,
        trade_change: `涨跌`,
        trade_coin_name: `Coin`,
        trade_set_price_field_to_current_highest_ask: `输入当前卖一价格`,
        trade_set_price_field_to_current_highest_bid: `输入当前买一价格`,
        trade_chart: `图表`,
        trade_order_submitted: `订单已提交`,
        trade_amount_can_not_be_empty: `数量不能为空`,
        trade_input_is_invaild: `输入的值无效`,
        trade_the_balance_is_not_enough: `可用余额不足`,
        trade_next: `向后`,
        trade_prev: `向前`,
        trade_no_record: `没有记录`,
        trade_amount_is_too_small: `金额过小`,
        trade_market_price_error: `提交失败，因为在市场中没有价格`,
        trade_cancel_order_success: `取消订单成功`,
        trade_market_price: `市场价格`,
        account_only_3_steps_it_won_t_take_much_longer: `只需三步即可完成创建`,
        acccount_important: `重要提醒`,
        account_back_your_account: `备份你的账户`,
        account_do_not_forge: `请谨记`,
        account_to_save_your_mnomenics_you_will_need_this: `备份你的助记词，你会需要`,
        account_confirm_mnemonic: `确认助记词`,
        account_fill_in_the_blanks_to_ensure_the_backup_is_correct: `填充空格以确保备份是正确的`,
        account_user_name_is_invaild: `账户名无效`,
        account_password_cannot_be_empty: `密码不能为空`,
        account_password_not_satisfied: `两次密码输入不一致`,
        account_i_have_read_this_warning: `我已阅读注意事项`,
        account_byteTrade_is_a_decentralized_system: `是一个去中心化系统，如果你遗失了账户数据，那么很抱歉我们无法恢复。`,
        account_do_it_later: `稍后再做`,
        account_please_agree_the_anouncement_below: `请先阅读下面的注意事项`,
        // not trans
        account_welcome_back: `欢迎归来`,
        account_by_mnemonics: `根据助记词`,
        account_by_private_key: `根据私钥`,
        account_type_your: `输入您的`,
        account_type_mnemonics: `助记词`,
        account_enter: `输入`,
        account_enter_password: `输入密码...`,
        account_repeat_password: `重复密码`,
        account_re_enter_password: `重新输入密码...`,
        account_or: `或者`,
        account_crete_account: `创建账户`,
        account_private_key: `私钥`,
        account_mnomenics_error: `助记词错误`,
        account_mnemonics_cannot_be_empty: `助记词不能为空`,
        account_password_unsame: `两个密码不相同`,
        account_username_is_already_exist: `用户已存在`,
        account_input_the_password: `输入密码`,
        account_mnomenics_was_incorrect: `助记词错误`,
        account_password_wrong: `密码错误`,
        account_username_not_exist: `用户不存在`,
        account_mnemonics_length_error: `助记词长度错误`,
        account_username_already_exist: `用户名已存在`,
        account_username_invaild: `用户名无效`,
        account_password_error: `密码错误`,
        account_fail_transfer: `转账失败`,
        balance_please_input_valid_address: `请输入合法的 {{asset}} 地址`,
        balance_estimated_value: `预估价值`,
        balance_input_your_message: `输入信息`,
        balance_deposit_address: `充值地址`,
        balance_deposit_address_new: `新地址`,
        balance_deposit_address_legacy: `旧地址`,
        balance_deposit_address_hint_bch: `BCH has two different formats of address. Both of them can store your coins correctly`,
        balance_deposit_convert: `切换`,
        balance_deposit_convert_hint: `Some wallet may not support the new address, so click the 'Convert' to change address format.`,
        balance_scan_this_qr_code: `扫描此二维码`,
        balance_please_go_to: `请前往`,
        balance_view_Progress: `查看进度`,
        balance_do_not_deposit_any_non_eth_assets_to_this_address: `请不要充值任何非{asset}资产到这个地址`,
        balance_min_deposit_amount: `最小充值金额：`,
        balance_min_withdraw_amount: `最小提现金额`,
        balance_be_sure_to_check_the_security: `请确保电脑与浏览器的安全性，以防止信息泄漏或被篡改`,
        order_no_more: `没有更多`,
        order_this_is_last_page: `这是最后一页了`,
        history_process_time: `处理时间`,
        history_transaction: `Transaction`,
        mainpage_banner_tatle: `专业安全透明的数字货币交易平台`,
        mainpage_advantage_title: `全球领先的加密货币去中心化交易平台`,
        mainpage_advantage_subtitle: `为全球100万的专业加密货币投资者提供安全、稳定、高效的资产交易服务`,
        mainpage_advantage_assetsecurity: `跨链资产安全`,
        mainpage_advantage_assetsecurity_details: `回归去中心化，用户私钥自持,掌握100%的资金管理权；用户资产锁定在智能合约,所有超级节点多重签名确保安`,
        mainpage_advantage_tradingspeed: `闪电般的交易速度`,
        mainpage_advantage_tradingspeed_details: `3 秒完成订单，与传统中心化交易所媲美的速度。凭借 ByteTrade Blockchain 的先进共识机制，实现性能与安全双重飞跃`,
        mainpage_advantage_crosschain: `完善的跨链机制`,
        mainpage_advantage_crosschain_details: `去中心化交易系统中仅有的真跨链解决方案，已全面支持BTC、USDT(ERC20)、ETH 、CMT等主流资产，更多公链持续集成`,
        mainpage_advantage_globalarrangement: `全球化布局`,
        mainpage_advantage_globalarrangement_details: `超级节点遍布全球四大洲8个国家，确保全球用户的极致交易体验。国际化团队构成，持续对接全球优质项目`,
        mainpage_advantage_kline: `专业的K线图表指标工具`,
        mainpage_advantage_kline_details: `交易界面回归中心化体验，熟悉顺手。专业客服7*24小时提供支持`,
        mainpage_latest_price: `最新价格`,
        mainpage_change: `涨跌幅`,
        p1: `东京`,
        p2: `弗吉尼亚`,
        p3: `伦敦`,
        p4: `新加坡`,
        p5: `悉尼`,
        p6: `圣保罗`,
        p7: `加利福尼亚`,
        p8: `首尔`,
        p9: `法兰克福`,
        p10: `俄亥俄州`,
        p11: `俄勒冈`,
        c1: `东京`,
        c2: `弗吉尼亚`,
        c3: `伦敦`,
        c4: `新加坡`,
        c5: `悉尼`,
        c6: `圣保罗`,
        c7: `加利福尼亚`,
        c8: `首尔`,
        c9: `法兰克福`,
        c10: `俄亥俄州`,
        c11: `俄勒冈`,
        zhCN: `简体中文`,
        success: `成功`,
        invalid_referrer_info: `推荐人信息错误`,
        invalid_referrer_info_desc: `查询不到此推荐人，请确认推荐链接是否正确或完整。点击"继续创建"将不使用推荐信息来完成账户创建，是否继续？`,
        invalid_referrer_info_cancel: `放弃创建`,
        invalid_referrer_info_create: `继续创建`,
        input_the_type_and_account_name: `请填写{type}与账户名，以空格分隔`,
        no_more_input_before_exit: `退出网页前不再输入`,
        kyc_function_name: 'KYC',
        kyc_step1_title: '第一步',
        kyc_step1_subtitle: '验证信息',
        kyc_step2_title: '第二步',
        kyc_step2_subtitle: '上传身份证明',
        kyc_step1_field1_title: '验证手机号码',
        kyc_step1_field1_content1: '输入手机号码',
        kyc_step1_field1_content2: '6位验证码',
        kyc_step1_field1_content3: '发送短信',
        kyc_step1_field1_content4: '重新发送',
        kyc_step1_field2_title: '验证电子邮箱',
        kyc_step1_field2_content1: '输入邮箱地址',
        kyc_step1_field2_content2: '6位验证码',
        kyc_step1_field2_content3: '发送邮件',
        kyc_step1_field2_content4: '重新发送',
        kyc_step1_confirm_button: '确认',
        kyc_step2_field1_title: '名',
        kyc_step2_field1_content: '名',
        kyc_step2_field2_title: '姓',
        kyc_step2_field2_content: '姓',
        kyc_step2_field3_title: '身份证明类型',
        kyc_step2_field3_content1: '身份证',
        kyc_step2_field3_content2: '护照',
        kyc_step2_field3_content3: '驾照',
        kyc_step2_field4_title: '文件ID',
        kyc_step2_field4_content: '请输入身份文件ID',
        kyc_step2_field5_title: '上传身份证明文件',
        kyc_step2_field5_subtitle: '请确保图片和文字清晰，否则会影响审核。',
        kyc_step2_field5_content1: '点击上传证件的正面照',
        kyc_step2_field5_content2: '点击上传证件的背面照',
        kyc_step2_field5_content3: '点击上传手持证件正面照的自拍',
        kyc_step2_field5_content4_1: '点击上传近3个月有效的住址证明',
        kyc_step2_field5_content4_2: 'a. 水电费（电费，煤气费，水费等）； \nb. 座机电话帐单； \nc. 信用卡或银行对帐单',
        kyc_status_processing: '你的ID信息正在审核中',
        kyc_status_succeed: '你的ID信息已验证成功',
        kyc_status_fail: '你的ID信息验证失败了',
        kyc_status_content1: '身份证件号码',
        kyc_status_content2: '原因',
        

    },
    es: {
		es: `Espanol`,
        trade_orderbook_sellorbuy: `vender comprar`,
		trade_orderbook_sellorbuy_price: `Precio`,
		trade_orderbook_sellorbuy_amount: `Cantidad`,
		trade_orderbook_sellorbuy_sum: `Suma`,
		trade_orderbook_sell: `Vender`,
		trade_orderbook_sell_price: `Precio`,
		trade_orderbook_sell_amount: `Cantidad`,
		trade_orderbook_sell_sum: `Suma`,
		trade_orderbook_buy: `Comprar`,
		trade_orderbook_buy_price: `Precio`,
		trade_orderbook_buy_amount: `Cantidad`,
		trade_orderbook_buy_sum: `Suma`,
		trade_orderbook_decimals: `decimales`,
		trade_markettrades: `Comercios de mercado`,
		trade_markettrades_price: `Precio`,
		trade_markettrades_amount: `Cantidad`,
		trade_markettrades_sum: `Suma`,
		trade_tradezone_limit: `Límite`,
		trade_tradezone_limit_price: `Precio`,
		trade_tradezone_limit_amount: `Cantidad`,
		trade_tradezone_limit_buy: `Comprar`,
		trade_tradezone_limit_sell: `Vender`,
		trade_tradezone_market: `Mercado`,
		trade_tradezone_market_price: `Precio`,
		trade_tradezone_market_amount: `Cantidad`,
		trade_tradezone_market_buy: `Comprar`,
		trade_tradezone_market_sell: `Vender`,
		trade_chart_kline: `Kline`,
		trade_chart_depth: `Profundidad`,
		trade_order_openorder: `Orden abierta`,
		trade_order_orderhistory: `Historial de pedidos`,
		trade_order_deals: `Ofertas`,
		Theamountislessthantheminimum: `El importe es inferior al mínimo.`,
		trade_order_hideotherpairs: `Ocultar otros pares`,
		trade_amount_is_greater_than_the_balance: `El monto es mayor que el saldo`,
		trade_cancel_order_success: `Cancelar pedido exitoso`,
		trade_the_best_market_pricde: `El mejor precio del mercado.`,
		trade_balance_not_enough: `Balance no suficiente`,
		balance_account_username: `Nombre de usuario`,
		balance_account_password: `Contraseña`,
		balance_account_repeatpassword: `Repite la contraseña`,
		balance_account_confirm: `CONFIRMAR`,
		delete_account: `Cerrar sesión en cuenta`,
		delete_account_tips1: `Tenga en cuenta que está saliendo de la información de la cuenta, asegúrese de hacer una copia de seguridad de la clave mnemónica o privada de esta cuenta, de lo contrario`,
		delete_account_tips2: `no podrá acceder permanentemente a esta cuenta`,
		delete_account_tips3: `resultando en pérdida de activos. La clave mnemónica y privada solo puede ser respaldada manualmente por usted, y el intercambio no puede recuperarla.`,
		delete_account_tips4: `Después de hacer clic para confirmar, ingrese la contraseña de acuerdo con la solicitud, el sistema descargará automáticamente un archivo mnemónico, guárdelo correctamente.`,
		delete_account_tips5: `Advertencia`,
		delete_account_tips6: `Consejos`,
		delete_account_confirm: `CONFIRMAR CERRAR SESIÓN`,
		account_logout: `Cerrar sesión`,
		balance_mnemonics_ihavereadthiswarning: `He leído esta advertencia`,
		balance_mnemonics_complete: `Completar`,
		balance_mnemonics_previous: `ANTERIOR`,
		balance_mnemonics_confirm: `CONFIRMAR`,
		balance_history: `Historia`,
		balance_history_deposithistory: `Historial de depósitos`,
		balance_history_deposithistory_time: `Hora`,
		balance_history_deposithistory_asset: `Activo`,
		balance_history_deposithistory_amount: `Cantidad`,
		balance_history_deposithistory_status: `Estado`,
		balance_history_deposithistory_action: `Acción`,
		balance_history_deposithistory_action_details: `Detalles`,
		balance_history_withdrawhistory: `Retirar historial`,
		balance_history_withdrawhistory_time: `Hora`,
		balance_history_withdrawhistory_asset: `Activo`,
		balance_history_withdrawhistory_amount: `Cantidad`,
		balance_history_withdrawhistory_status: `Estado`,
		balance_history_withdrawhistory_action: `Acción`,
		balance_history_withdrawhistory_action_details: `Detalles`,
		balance_history_transferhistory: `Historial de transferencias`,
		balance_fiat_transferhistory: `Historia de Fiat`,
		balance_history_transferhistory_time: `Hora`,
		balance_history_transferhistory_asset: `Activo`,
		balance_history_transferhistory_amount: `Cantidad`,
		balance_history_transferhistory_status: `Estado`,
		balance_history_transferhistory_action: `Acción`,
		balance_history_transferhistory_action_details: `Detalles`,
		balance_view_on_explorer: `ver en el explorador`,
		balance_balancezone_hide0balance: `Ocultar saldo 0`,
		balance_balancezone_search: `Buscar`,
		balance_balancezone_symbol: `Símbolo`,
		balance_balancezone_balance: `Equilibrar`,
		balance_balancezone_freeze: `Congelar`,
		balance_balancezone_available: `Disponible`,
		balance_balancezone_action: `Acción`,
		balance_balancezone_transfer: `Transferir`,
		balance_balancezone_transfer_to: `A`,
		balance_balancezone_transfer_receiversaccount: `cuenta de receptor`,
		balance_balancezone_transfer_amount: `Cantidad`,
		balance_balancezone_transfer_typeamount: `cantidad de tipo`,
		balance_balancezone_transfer_message: `Mensaje`,
		balance_balancezone_transfer_cancel: `Cancelar`,
		balance_balancezone_transfer_confirm: `Confirmar`,
		balance_balancezone_deposit: `Depositar`,
		balance_balancezone_deposit_copy: `Copiar`,
		balance_balancezone_withdraw: `Retirar`,
		balance_balancezone_fiat_out: `FiatOut`,
		balance_balancezone_withdraw_address: `Habla a`,
		balance_balancezone_withdraw_inputyourwithdrawaddress: `ingrese su dirección de retiro`,
		balance_balancezone_withdraw_amount: `Cantidad`,
		balance_balancezone_withdraw_typeamount: `cantidad de tipo`,
		balance_balancezone_withdraw_confirm: `Confirmar`,
		balance_copy_success: `Copiar el éxito!`,
		balance_please_input_address_and_amount: `Por favor ingrese la dirección y la cantidad!`,
		balance_successful_withdraw: `Retiro exitoso`,
		orders_ordersrecord_openorders: `Ordenes abiertas`,
		balance_withdraw_address: `Retirar dirección`,
		orders_ordersrecord_openorders_time: `Hora`,
		orders_ordersrecord_openorders_market: `Mercado`,
		orders_ordersrecord_openorders_side: `Lado`,
		orders_ordersrecord_openorders_price: `Precio`,
		orders_ordersrecord_openorders_amount: `Cantidad`,
		orders_ordersrecord_openorders_total: `Total`,
		orders_ordersrecord_openorders_filled: `Lleno%`,
		orders_ordersrecord_openorders_action: `Acción`,
		orders_ordersrecord_orderhistory: `Historial de pedidos`,
		orders_ordersrecord_orderhistory_time: `Hora`,
		orders_ordersrecord_orderhistory_market: `Mercado`,
		orders_ordersrecord_orderhistory_side: `Lado`,
		orders_ordersrecord_orderhistory_price: `Precio`,
		orders_ordersrecord_orderhistory_amount: `Cantidad`,
		orders_ordersrecord_orderhistory_total: `Total`,
		orders_ordersrecord_orderhistory_filled: `Lleno%`,
		orders_ordersrecord_orderhistory_action: `Acción`,
		orders_ordersrecord_deals: `Ofertas`,
		orders_ordersrecord_deals_time: `Hora`,
		orders_ordersrecord_deals_market: `Mercado`,
		orders_ordersrecord_deals_side: `Lado`,
		orders_ordersrecord_deals_price: `Precio`,
		orders_ordersrecord_deals_amount: `Cantidad`,
		orders_ordersrecord_deals_total: `Total`,
		orders_ordersrecord_deals_filled: `Lleno%`,
		orders_ordersrecord_deals_action: `Acción`,
		nav_trade: `Comercio`,
		nav_balance: `Equilibrar`,
		nav_orders: `Pedidos`,
		nav_faq: `Preguntas más frecuentes`,
		nav_fiat: `Fíat`,
		nav_explorer: `Explorador`,
		nav_country_virginia: `Virginia`,
		nav_country_singapore: `Singapur`,
		nav_language_english: `Inglés`,
		nav_create: `Crear`,
		nav_create_username: `Nombre de usuario`,
		nav_create_password: `Contraseña`,
		nav_create_repeatpassword: `Repite la contraseña`,
		nav_create_confirm: `CONFIRMAR`,
		nav_create_back: `atrás`,
		nav_or: `O`,
		nav_import: `Importar`,
		nav_import_bymnemonics: `Por mnemotecnia`,
		nav_import_typeyourmnemonics: `Escribe tus mnemotécnicos`,
		nav_import_entermnemonics: `Entra en mnemotecnia`,
		nav_import_password: `Contraseña`,
		nav_import_enterpassword: `Introducir la contraseña`,
		nav_import_repeatpassword: `repite la contraseña`,
		nav_import_reenterpassword: `Escriba la contraseña otra vez`,
		nav_import_byprivatekey: `Por clave privada`,
		nav_import_typeyourprivatekey: `Escriba su clave privada`,
		nav_import_enterprivatekey: `Ingresar clave privada`,
		nav_import_confirm: `CONFIRMAR`,
		nav_import_createaccount: `crear una cuenta`,
		nav_import_back: `atrás`,
		account_copy: `Copiar`,
		account_view: `Ver`,
		account_export: `Exportar`,
		account_export_verifypassword: `Verificar contraseña`,
		account_export_entersomething: `Introduce algo`,
		account_export_confirm: `CONFIRMAR`,
		account_switchaccount: `Cambiar cuenta`,
		account_createnewaccount: `Crear una nueva cuenta`,
		account_importaccount: `Cuenta de importación`,
		account_createasset: `Crear activo`,
		account_createmarket: `Crear mercado`,
		account_what_is_mnomenics: `¿Qué es el fenómeno?`,
		footer_ecology: `Ecología`,
		footer_ecology_bytetradeblockchain: `Bytetrade Blockchain`,
		footer_ecology_downloadclients: `Descargar clientes`,
		footer_ecology_pitiopaymentprotocal: `Protocolo de pago PITIO`,
		footer_support: `Apoyo`,
		footer_support_createaccount: `Crear una cuenta`,
		footer_support_deposit: `Depositar`,
		footer_support_withdraw: `Retirar`,
		footer_support_fees: `Tarifa`,
		footer_support_fee: `Cuota`,
		footer_support_more: `Más`,
		footer_contact: `Contacto`,
		footer_contact_listtoken: `ListToken`,
		footer_socialmedia: `Redes sociales`,
		footer_mediakit_telegram: `Telegrama`,
		footer_mediakit_facebook: `Facebook`,
		footer_mediakit_twitter: `Gorjeo`,
		footer_mediakit_medium: `Medio`,
		trade_high: `Alto`,
		trade_low: `Bajo`,
		trade_volume: `Volumen`,
		trade_change: `Cambio`,
		trade_turnover: `Rotación`,
		trade_coin_name: `Moneda`,
		trade_set_price_field_to_current_highest_ask: `Establecer el campo de precio a la demanda más baja actual`,
		trade_set_price_field_to_current_highest_bid: `Establecer el campo de precio a la oferta más alta actual`,
		trade_set_price_field_to_current_low_ask: `Establecer el campo de precio a la demanda más baja actual`,
		trade_set_price_field_to_current_low_bid: `Establecer el campo de precio a la oferta más baja actual`,
		trade_chart: `Gráfico`,
		trade_order_submitted: `orden enviada`,
		trade_amount_can_not_be_empty: `la cantidad no puede estar vacía`,
		trade_input_is_invaild: `la entrada es invaild`,
		trade_the_balance_is_not_enough: `Lo disponible no es suficiente`,
		trade_next: `próximo`,
		trade_prev: `Anterior`,
		trade_no_record: `Sin registro`,
		trade_amount_is_too_small: `La cantidad es demasiado pequeña`,
		trade_market_price_error: `La presentación falló, porque no tiene precio en el mercado.`,
		trade_market_price: `Precio de mercado`,
		account_only_3_steps_it_won_t_take_much_longer: `Solo 3 pasos, no tomará mucho más tiempo`,
		acccount_important: `Importante`,
		account_back_your_account: `Respalda tu cuenta`,
		account_do_not_forge: `NO LO OLVIDE`,
		account_to_save_your_mnomenics_you_will_need_this: `para salvar tu momento. Necesitarás esto`,
		account_confirm_mnemonic: `Confirmar mnemotécnico`,
		account_fill_in_the_blanks_to_ensure_the_backup_is_correct: `Complete los espacios en blanco para asegurarse de que la copia de seguridad sea correcta`,
		account_user_name_is_invaild: `Nombre de usuario es invaild`,
		account_password_not_satisfied: `la contraseña no coincide`,
		account_i_have_read_this_warning: `He leído esta advertencia`,
		account_byteTrade_is_a_decentralized_system: ` es un sistema descentralizado. Si pierde la información de su cuenta de esta computadora, lamentamos no poder recuperarla.`,
		account_do_it_later: `Hazlo después`,
		account_please_agree_the_anouncement_below: `Por favor, acepte el anuncio a continuación`,
		//nottrans: ``,
		account_welcome_back: `Dar una buena acogida`,
		account_by_mnemonics: `Por mnemotecnia`,
		account_by_private_key: `Por clave privada`,
		account_type_your: `Escriba su`,
		account_type_mnemonics: `mnemotécnica`,
		account_enter: `Entrar`,
		account_enter_password: `Introducir la contraseña...`,
		account_repeat_password: `repite la contraseña`,
		account_re_enter_password: `Escriba la contraseña otra vez...`,
		account_or: `O`,
		account_crete_account: `Cuenta de Creta`,
		account_private_key: `Llave privada`,
		account_mnomenics_error: `Error de Mnomenics`,
		account_mnemonics_cannot_be_empty: `la mnemotecnia no puede estar vacía`,
		account_password_cannot_be_empty: `la contraseña no puede estar vacía`,
		account_password_unsame: `contraseña no igual contraseña reepat`,
		account_username_is_already_exist: `nombre de usuario ya existe`,
		account_input_the_password: `ingrese la contraseña`,
		account_mnomenics_was_incorrect: `El fenómeno era incorrecto`,
		account_password_wrong: `Contraseña incorrecta`,
		account_username_not_exist: `Este nombre de cuenta dosen \ t existe en nuestra cadena de bloques`,
		account_mnemonics_length_error: `error de longitud de mnemotécnicos`,
		account_username_already_exist: `el nombre de usuario ya existe`,
		account_username_invaild: `nombre de usuario invaild`,
		account_password_error: `error de contraseña`,
		account_fail_transfer: `transferencia fallida`,
		balance_estimated_value: `Valor estimado`,
		balance_input_your_message: `Ingrese su mensaje aquí`,
		balance_deposit_address: `Dirección de depósito`,
		balance_scan_this_qr_code: `Escanea este código QR`,
		balance_please_go_to: `Por favor ve a`,
		balance_view_Progress: `ver progreso`,
		balance_do_not_deposit_any_non_eth_assets_to_this_address: `No deposite ningún activo que no sea {activo} en esta dirección`,
		balance_min_deposit_amount: `Cantidad mínima de depósito`,
		balance_min_withdraw_amount: `Cantidad mínima de retiro`,
		balance_be_sure_to_check_the_security: `Asegúrese de verificar la seguridad de su computadora y navegador para evitar que la información sea manipulada o filtrada`,
		balance_successful_transfer: `transferencia exitosa`,
		balance_please_input_valid_address: `Ingrese una dirección válida de {activo}`,
		order_no_more: `no más`,
		order_this_is_last_page: `esta es la ultima pagina`,
		history_process_time: `Tiempo de procesamiento`,
		history_transaction: `Transacción`,
		mainpage_banner_tatle: `Plataforma de comercio de criptomonedas profesional, segura y transparente`,
		mainpage_advantage_title: `La plataforma de comercio descentralizada de criptomonedas líder en el mundo`,
		mainpage_advantage_subtitle: `Brindar servicios de comercio de activos seguros, estables y eficientes a los inversores profesionales mundiales en criptomonedas`,
		mainpage_advantage_assetsecurity: `Seguridad de activos de cadena cruzada`,
		mainpage_advantage_assetsecurity_details: `Sus activos están bloqueados de forma segura en contratos inteligentes que requieren firmas múltiples en todos los supernodos para completar las transacciones.`,
		mainpage_advantage_assetsecurity_details_1: `100% descentralizado para que solo usted tenga acceso a sus activos utilizando su clave privada.`,
		mainpage_advantage_tradingspeed: `Velocidad comercial de rayos`,
		mainpage_advantage_tradingspeed_details: `Nuestro avanzado mecanismo de consenso de blockchain logra un rendimiento y una seguridad superiores al completar pedidos en 3 segundos. Características valiosas para todos los comerciantes e inversores.`,
		mainpage_advantage_crosschain: `Perfecto mecanismo de cadena cruzada`,
		mainpage_advantage_crosschain_details: `La única solución verdadera de cadena cruzada en el sistema de comercio descentralizado.`,
		mainpage_advantage_crosschain_details_1: `Admitimos BTC、USDT(ERC20)、ETH 、CMT y otros activos de blockchain convencionales. Continuamos construyendo el alcance de su comercio.`,
		mainpage_advantage_globalarrangement: `Arreglo global`,
		mainpage_advantage_globalarrangement_details: `Para garantizar la mejor experiencia comercial para todos los usuarios de todo el mundo, se implementan supernodos en 8 países en 4 continentes.`,
		mainpage_advantage_kline: `Herramienta profesional de indicador de línea K`,
		mainpage_advantage_kline_details: `Nuestro servicio de atención al cliente profesional está disponible las 24 horas, los 7 días de la semana.`,
		mainpage_latest_price: `Último precio`,
		mainpage_change: `Cambio`,
		c1: `Tokio`,
		c2: `Virginia`,
		c3: `Londres`,
		c4: `Singapur`,
		c5: `Sydney`,
		c6: `Sao Paulo`,
		c7: `California`,
		c8: `Seúl`,
		c9: `Frankfurt`,
		c10: `Ohio`,
		c11: `Oregón`,
		p1: `Tokio`,
		p2: `Virginia`,
		p3: `Londres`,
		p4: `Singapur`,
		p5: `Sydney`,
		p6: `Sao Paulo`,
		p7: `California`,
		p8: `Seúl`,
		p9: `Frankfurt`,
		p10: `Ohio`,
		p11: `Oregón`,
		en: `Inglés`,
		password: `Contraseña`,
		confirmpw: `Confirmar contraseña`,
		signup: `REGÍSTRATE`,
		alreadysu: `¿Registrado?`,
		login: `INICIAR SESIÓN`,
		signuptitle: `BIENVENIDOS A GATEWAYSTAR`,
		email: `Email`,
		signupwelcome: `BIENVENIDOS A GATEWAYSTAR`,
		confirm: `CONFIRMAR`,
		forgetpw: `Olvidaste tu contraseña`,
		passwordWrong: `Contraseña de al menos 8 caracteres y contiene letras y números en inglés`,
		emailWrong: `Dirección de correo electrónico no válida`,
		loginWrong: `Emal o contraseña incorrecta`,
		userExits: `El correo electrónico ya existe`,
		passwordIsSame: `Esas contraseñas no coincidían`,
		pleaseInputRightEmail: `Por favor ingrese el correo electrónico correcto`,
		success: `Éxito`,
		invalid_referrer_info: `Información de referencia inválida`,
		invalid_referrer_info_desc: `Esta cuenta de referencia está disponible, asegúrese de que el enlace de referencia sea correcto o esté completo. Al hacer clic en "Continuar para crear" no se usará la información de referencia para completar la creación de la cuenta. ¿Estás seguro de continuar?`,
		invalid_referrer_info_cancel: `Cancelar`,
		invalid_referrer_info_create: `Continuar para crear`,
		input_the_type_and_account_name: `Ingrese el {tipo} y el nombre de la cuenta, separados por espacios`,
        kyc_function_name: 'KYC',
        kyc_step1_title: 'Paso 1',
        kyc_step1_subtitle: 'Verificar información',
        kyc_step2_title: 'Paso 2',
        kyc_step2_subtitle: 'Subir imagen de identidad',
        kyc_step1_field1_title: 'Verificar número de teléfono',
        kyc_step1_field1_content1: 'Ingrese su número de teléfono',
        kyc_step1_field1_content2: '6 Código digital',
        kyc_step1_field1_content3: 'Enviar código de SMS',
        kyc_step1_field1_content4: 'Reenviar',
        kyc_step1_field2_title: 'Confirme su dirección de correo electrónico',
        kyc_step1_field2_content1: 'Ingrese su dirección de correo electrónico',
        kyc_step1_field2_content2: '6 Código digital',
        kyc_step1_field2_content3: 'Enviar correo electrónico',
        kyc_step1_field2_content4: 'Reenviar',
        kyc_step1_confirm_button: 'CONFIRMAR',
        kyc_step2_field1_title: 'Nombre de pila',
        kyc_step2_field1_content: 'Nombre de pila',
        kyc_step2_field2_title: 'Apellido',
        kyc_step2_field2_content: 'Apellido',
        kyc_step2_field3_title: 'Tipo de identidad',
        kyc_step2_field3_content1: 'Tarjeta de identificación nacional',
        kyc_step2_field3_content2: 'Pasaporte',
        kyc_step2_field3_content3: 'Licencia de conducir',
        kyc_step2_field4_title: 'Número del Documento',
        kyc_step2_field4_content: 'Ingrese el número de identidad',
        kyc_step2_field5_title: 'Subir documento de identidad',
        kyc_step2_field5_subtitle: '* Asegúrate de que la foto y el texto sean claros, de lo contrario puede afectar la revisión',
        kyc_step2_field5_content1: 'Haga clic para cargar la foto frontal del documento',
        kyc_step2_field5_content2: 'Haga clic para cargar la foto posterior del documento',
        kyc_step2_field5_content3: 'Haga clic para cargar una selfie de sostener el frente del documento de identidad',
        kyc_step2_field5_content4_1: 'Haga clic para cargar un comprobante de domicilio válido con menos de 3 meses de antigüedad',
        kyc_step2_field5_content4_2: 'a. Facturas de servicios públicos (electricidad, gas, agua, etc.); \n b. Factura de teléfono fijo; \n c. Tarjeta de crédito o extracto bancario',
        kyc_status_processing: 'Su información de identificación está bajo revisión',
        kyc_status_succeed: 'Su información de identificación ha sido verificada.',
        kyc_status_fail: 'Su verificación de identidad ha fallado',
        kyc_status_content1: 'Documento núm.:',
        kyc_status_content2: 'Razón',
    },
    de: {
		de: `Deutsch`,
        trade_orderbook_sellorbuy: `verkaufen kaufen`,
		trade_orderbook_sellorbuy_price: `Preis`,
		trade_orderbook_sellorbuy_amount: `Menge`,
		trade_orderbook_sellorbuy_sum: `Summe`,
		trade_orderbook_sell: `Verkaufen`,
		trade_orderbook_sell_price: `Preis`,
		trade_orderbook_sell_amount: `Menge`,
		trade_orderbook_sell_sum: `Summe`,
		trade_orderbook_buy: `Kaufen`,
		trade_orderbook_buy_price: `Preis`,
		trade_orderbook_buy_amount: `Menge`,
		trade_orderbook_buy_sum: `Summe`,
		trade_orderbook_decimals: `Dezimalstellen`,
		trade_markettrades: `Marktgeschäfte`,
		trade_markettrades_price: `Preis`,
		trade_markettrades_amount: `Menge`,
		trade_markettrades_sum: `Summe`,
		trade_tradezone_limit: `Grenze`,
		trade_tradezone_limit_price: `Preis`,
		trade_tradezone_limit_amount: `Menge`,
		trade_tradezone_limit_buy: `Kaufen`,
		trade_tradezone_limit_sell: `Verkaufen`,
		trade_tradezone_market: `Markt`,
		trade_tradezone_market_price: `Preis`,
		trade_tradezone_market_amount: `Menge`,
		trade_tradezone_market_buy: `Kaufen`,
		trade_tradezone_market_sell: `Verkaufen`,
		trade_chart_kline: `Kline`,
		trade_chart_depth: `Tiefe`,
		trade_order_openorder: `Offene Bestellung`,
		trade_order_orderhistory: `Bestellverlauf`,
		trade_order_deals: `Angebote`,
		Theamountislessthantheminimum: `Die Menge ist geringer als das Minimum`,
		trade_order_hideotherpairs: `Andere Paare ausblenden`,
		trade_amount_is_greater_than_the_balance: `Betrag ist größer als der Saldo`,
		trade_cancel_order_success: `Bestellung erfolgreich stornieren`,
		trade_the_best_market_pricde: `Der beste Marktpreis`,
		trade_balance_not_enough: `Balance nicht genug`,
		balance_account_username: `Nutzername`,
		balance_account_password: `Passwort`,
		balance_account_repeatpassword: `Wiederhole das Passwort`,
		balance_account_confirm: `BESTÄTIGEN`,
		delete_account: `Abmelden Konto`,
		delete_account_tips1: `Bitte beachten Sie, dass Sie sich von den Kontoinformationen abmelden. Stellen Sie sicher, dass Sie die Mnemonik oder den privaten Schlüssel dieses Kontos sichern, andernfalls`,
		delete_account_tips2: `wird dauerhaft nicht auf dieses Konto zugreifen können`,
		delete_account_tips3: `was zum Verlust von Vermögenswerten führt. Die Mnemonik und der private Schlüssel können nur manuell von Ihnen gesichert werden, und der Exchange kann sie nicht abrufen.`,
		delete_account_tips4: `Nach dem Klicken zur Bestätigung geben Sie das Passwort gemäß der Eingabeaufforderung ein. Das System lädt automatisch eine Mnemonic-Datei herunter. Bitte speichern Sie diese ordnungsgemäß.`,
		delete_account_tips5: `Warnung`,
		delete_account_tips6: `Tipps`,
		delete_account_confirm: `LOGOUT BESTÄTIGEN`,
		account_logout: `Ausloggen`,
		balance_mnemonics_ihavereadthiswarning: `Ich habe diese Warnung gelesen`,
		balance_mnemonics_complete: `Komplett`,
		balance_mnemonics_previous: `BISHERIGE`,
		balance_mnemonics_confirm: `BESTÄTIGEN`,
		balance_history: `Geschichte`,
		balance_history_deposithistory: `Einzahlungsverlauf`,
		balance_history_deposithistory_time: `Zeit`,
		balance_history_deposithistory_asset: `Anlagegut`,
		balance_history_deposithistory_amount: `Menge`,
		balance_history_deposithistory_status: `Status`,
		balance_history_deposithistory_action: `Aktion`,
		balance_history_deposithistory_action_details: `Einzelheiten`,
		balance_history_withdrawhistory: `Verlauf zurückziehen`,
		balance_history_withdrawhistory_time: `Zeit`,
		balance_history_withdrawhistory_asset: `Anlagegut`,
		balance_history_withdrawhistory_amount: `Menge`,
		balance_history_withdrawhistory_status: `Status`,
		balance_history_withdrawhistory_action: `Aktion`,
		balance_history_withdrawhistory_action_details: `Einzelheiten`,
		balance_history_transferhistory: `Übertragungsverlauf`,
		balance_fiat_transferhistory: `Fiat Geschichte`,
		balance_history_transferhistory_time: `Zeit`,
		balance_history_transferhistory_asset: `Anlagegut`,
		balance_history_transferhistory_amount: `Menge`,
		balance_history_transferhistory_status: `Status`,
		balance_history_transferhistory_action: `Aktion`,
		balance_history_transferhistory_action_details: `Einzelheiten`,
		balance_view_on_explorer: `Ansicht auf Entdecker`,
		balance_balancezone_hide0balance: `0 Balance verstecken`,
		balance_balancezone_search: `Suche`,
		balance_balancezone_symbol: `Symbol`,
		balance_balancezone_balance: `Balance`,
		balance_balancezone_freeze: `Einfrieren`,
		balance_balancezone_available: `Verfügbar`,
		balance_balancezone_action: `Aktion`,
		balance_balancezone_transfer: `Transfer`,
		balance_balancezone_transfer_to: `Zu`,
		balance_balancezone_transfer_receiversaccount: `Empfängerkonto`,
		balance_balancezone_transfer_amount: `Menge`,
		balance_balancezone_transfer_typeamount: `Betrag eingeben`,
		balance_balancezone_transfer_message: `Botschaft`,
		balance_balancezone_transfer_cancel: `Stornieren`,
		balance_balancezone_transfer_confirm: `Bestätigen`,
		balance_balancezone_deposit: `Anzahlung`,
		balance_balancezone_deposit_copy: `Kopieren`,
		balance_balancezone_withdraw: `Abheben`,
		balance_balancezone_fiat_out: `FiatOut`,
		balance_balancezone_withdraw_address: `Adresse`,
		balance_balancezone_withdraw_inputyourwithdrawaddress: `Geben Sie Ihre Abhebungsadresse ein`,
		balance_balancezone_withdraw_amount: `Menge`,
		balance_balancezone_withdraw_typeamount: `Betrag eingeben`,
		balance_balancezone_withdraw_confirm: `Bestätigen`,
		balance_copy_success: `Kopieren Sie Erfolg!`,
		balance_please_input_address_and_amount: `Bitte geben Sie Adresse und Betrag ein!`,
		balance_successful_withdraw: `Erfolgreicher Rückzug`,
		orders_ordersrecord_openorders: `Offene Bestellungen`,
		balance_withdraw_address: `Adresse zurückziehen`,
		orders_ordersrecord_openorders_time: `Zeit`,
		orders_ordersrecord_openorders_market: `Markt`,
		orders_ordersrecord_openorders_side: `Seite`,
		orders_ordersrecord_openorders_price: `Preis`,
		orders_ordersrecord_openorders_amount: `Menge`,
		orders_ordersrecord_openorders_total: `Gesamt`,
		orders_ordersrecord_openorders_filled: `Gefüllt%`,
		orders_ordersrecord_openorders_action: `Aktion`,
		orders_ordersrecord_orderhistory: `Bestellverlauf`,
		orders_ordersrecord_orderhistory_time: `Zeit`,
		orders_ordersrecord_orderhistory_market: `Markt`,
		orders_ordersrecord_orderhistory_side: `Seite`,
		orders_ordersrecord_orderhistory_price: `Preis`,
		orders_ordersrecord_orderhistory_amount: `Menge`,
		orders_ordersrecord_orderhistory_total: `Gesamt`,
		orders_ordersrecord_orderhistory_filled: `Gefüllt%`,
		orders_ordersrecord_orderhistory_action: `Aktion`,
		orders_ordersrecord_deals: `Angebote`,
		orders_ordersrecord_deals_time: `Zeit`,
		orders_ordersrecord_deals_market: `Markt`,
		orders_ordersrecord_deals_side: `Seite`,
		orders_ordersrecord_deals_price: `Preis`,
		orders_ordersrecord_deals_amount: `Menge`,
		orders_ordersrecord_deals_total: `Gesamt`,
		orders_ordersrecord_deals_filled: `Gefüllt%`,
		orders_ordersrecord_deals_action: `Aktion`,
		nav_trade: `Handel`,
		nav_balance: `Balance`,
		nav_orders: `Aufträge`,
		nav_faq: `FAQ`,
		nav_fiat: `Fiat`,
		nav_explorer: `Forscher`,
		nav_country_virginia: `Virginia`,
		nav_country_singapore: `Singapur`,
		nav_language_english: `Englisch`,
		nav_create: `Erstellen`,
		nav_create_username: `Nutzername`,
		nav_create_password: `Passwort`,
		nav_create_repeatpassword: `Wiederhole das Passwort`,
		nav_create_confirm: `BESTÄTIGEN`,
		nav_create_back: `Zurück`,
		nav_or: `ODER`,
		nav_import: `Importieren`,
		nav_import_bymnemonics: `Mit Mnemonics`,
		nav_import_typeyourmnemonics: `Geben Sie Ihre Mnemonik ein`,
		nav_import_entermnemonics: `Mnemonics eingeben`,
		nav_import_password: `Passwort`,
		nav_import_enterpassword: `Passwort eingeben`,
		nav_import_repeatpassword: `Wiederhole das Passwort`,
		nav_import_reenterpassword: `Kennwort erneut eingeben`,
		nav_import_byprivatekey: `Mit privatem Schlüssel`,
		nav_import_typeyourprivatekey: `Geben Sie Ihren privaten Schlüssel ein`,
		nav_import_enterprivatekey: `Geben Sie den privaten Schlüssel ein`,
		nav_import_confirm: `BESTÄTIGEN`,
		nav_import_createaccount: `Konto erstellen`,
		nav_import_back: `Zurück`,
		account_copy: `Kopieren`,
		account_view: `Aussicht`,
		account_export: `Export`,
		account_export_verifypassword: `Passwort bestätigen`,
		account_export_entersomething: `Gib etwas ein`,
		account_export_confirm: `BESTÄTIGEN`,
		account_switchaccount: `Benutzer wechseln`,
		account_createnewaccount: `Neuen Account erstellen`,
		account_importaccount: `Konto importieren`,
		account_createasset: `Asset erstellen`,
		account_createmarket: `Markt schaffen`,
		account_what_is_mnomenics: `Was ist Mnomenics?`,
		footer_ecology: `Ökologie`,
		footer_ecology_bytetradeblockchain: `Bytetrade Blockchain`,
		footer_ecology_downloadclients: `Clients herunterladen`,
		footer_ecology_pitiopaymentprotocal: `PITIO Zahlungsprotokoll`,
		footer_support: `Unterstützung`,
		footer_support_createaccount: `Konto erstellen`,
		footer_support_deposit: `Anzahlung`,
		footer_support_withdraw: `Abheben`,
		footer_support_fees: `Gebühren`,
		footer_support_fee: `Gebühr`,
		footer_support_more: `Mehr`,
		footer_contact: `Kontakt`,
		footer_contact_listtoken: `ListToken`,
		footer_socialmedia: `Sozialen Medien`,
		footer_mediakit_telegram: `Telegramm`,
		footer_mediakit_facebook: `Facebook`,
		footer_mediakit_twitter: `Twitter`,
		footer_mediakit_medium: `Mittel`,
		trade_high: `Hoch`,
		trade_low: `Niedrig`,
		trade_volume: `Volumen`,
		trade_change: `Veränderung`,
		trade_turnover: `Umsatz`,
		trade_coin_name: `Münze`,
		trade_set_price_field_to_current_highest_ask: `Stellen Sie das Preisfeld auf den aktuell niedrigsten Preis ein`,
		trade_set_price_field_to_current_highest_bid: `Setzen Sie das Preisfeld auf das aktuelle Höchstgebot`,
		trade_set_price_field_to_current_low_ask: `Stellen Sie das Preisfeld auf den aktuell niedrigsten Preis ein`,
		trade_set_price_field_to_current_low_bid: `Setzen Sie das Preisfeld auf das aktuell niedrigste Gebot`,
		trade_chart: `Diagramm`,
		trade_order_submitted: `Bestellung übermittelt`,
		trade_amount_can_not_be_empty: `Menge kann nicht leer sein`,
		trade_input_is_invaild: `Die Eingabe ist ungültig`,
		trade_the_balance_is_not_enough: `Das Vorhandene ist nicht genug`,
		trade_next: `Nächster`,
		trade_prev: `Zurück`,
		trade_no_record: `Keine Aufzeichnungen`,
		trade_amount_is_too_small: `Menge ist zu klein`,
		trade_market_price_error: `Einreichung fehlgeschlagen, weil kein Preis auf dem Markt hat.`,
		trade_market_price: `Marktpreis`,
		account_only_3_steps_it_won_t_take_much_longer: `Nur 3 Schritte, es dauert nicht viel länger`,
		acccount_important: `Wichtig`,
		account_back_your_account: `Sichern Sie Ihr Konto`,
		account_do_not_forge: `NICHT VERGESSEN`,
		account_to_save_your_mnomenics_you_will_need_this: `um deine mnomenics zu retten. Du wirst das brauchen`,
		account_confirm_mnemonic: `Bestätigen Sie die Mnemonik`,
		account_fill_in_the_blanks_to_ensure_the_backup_is_correct: `Füllen Sie die Lücken aus, um sicherzustellen, dass die Sicherung korrekt ist`,
		account_user_name_is_invaild: `Benutzername ist ungültig`,
		account_password_not_satisfied: `Passwort stimmt nicht überein`,
		account_i_have_read_this_warning: `Ich habe diese Warnung gelesen`,
		account_byteTrade_is_a_decentralized_system: ` ist ein dezentrales System. Wenn Sie Ihre Kontoinformationen von diesem Computer verlieren, können wir sie leider nicht abrufen.`,
		account_do_it_later: `Mach es später`,
		account_please_agree_the_anouncement_below: `Bitte stimmen Sie der Ankündigung unten zu`,
		//nottrans: ``,
		account_welcome_back: `Willkommen zurück`,
		account_by_mnemonics: `Mit Mnemonics`,
		account_by_private_key: `Mit privatem Schlüssel`,
		account_type_your: `Geben Sie Ihre`,
		account_type_mnemonics: `Mnemonik`,
		account_enter: `Eingeben`,
		account_enter_password: `Passwort eingeben...`,
		account_repeat_password: `Wiederhole das Passwort`,
		account_re_enter_password: `Kennwort erneut eingeben...`,
		account_or: `ODER`,
		account_crete_account: `Kreta Konto`,
		account_private_key: `Privat Schlüssel`,
		account_mnomenics_error: `Mnomenics-Fehler`,
		account_mnemonics_cannot_be_empty: `Mnemonics dürfen nicht leer sein`,
		account_password_cannot_be_empty: `Passwort kann nicht leer sein`,
		account_password_unsame: `Passwort nicht gleich Passwort wiederholen`,
		account_username_is_already_exist: `Benutzername ist bereits vorhanden`,
		account_input_the_password: `Geben Sie das Passwort ein`,
		account_mnomenics_was_incorrect: `Mnomenics war falsch`,
		account_password_wrong: `Falsches Passwort`,
		account_username_not_exist: `Dieser Kontoname existiert nicht in unserer Blockchain`,
		account_mnemonics_length_error: `mnemonischer Längenfehler`,
		account_username_already_exist: `der Benutzername existiert bereits`,
		account_username_invaild: `Benutzername ungültig`,
		account_password_error: `Passwort-Fehler`,
		account_fail_transfer: `Übertragung fehlgeschlagen`,
		balance_estimated_value: `Geschätzter Wert`,
		balance_input_your_message: `Geben Sie hier Ihre Nachricht ein`,
		balance_deposit_address: `Einzahlungsadresse`,
		balance_scan_this_qr_code: `Scannen Sie diesen QR-Code`,
		balance_please_go_to: `Bitte gehe zu`,
		balance_view_Progress: `Fortschritt anzeigen`,
		balance_do_not_deposit_any_non_eth_assets_to_this_address: `Hinterlegen Sie an dieser Adresse keine Nicht-Vermögenswerte`,
		balance_min_deposit_amount: `Mindesteinzahlungsbetrag`,
		balance_min_withdraw_amount: `Min. Auszahlungsbetrag`,
		balance_be_sure_to_check_the_security: `Überprüfen Sie unbedingt die Sicherheit Ihres Computers und Ihres Browsers, um zu verhindern, dass Informationen manipuliert werden oder verloren gehen`,
		balance_successful_transfer: `erfolgreiche Übertragung`,
		balance_please_input_valid_address: `Bitte geben Sie eine gültige {asset} Adresse ein`,
		order_no_more: `nicht mehr`,
		order_this_is_last_page: `Dies ist die letzte Seite`,
		history_process_time: `Prozess Zeit`,
		history_transaction: `Transaktion`,
		mainpage_banner_tatle: `Professionelle, sichere und transparente Kryptowährungs-Handelsplattform`,
		mainpage_advantage_title: `Die weltweit führende dezentrale Cryptocurrency-Handelsplattform`,
		mainpage_advantage_subtitle: `Bereitstellung sicherer, stabiler und effizienter Dienstleistungen für den Handel mit Vermögenswerten für globale professionelle Kryptowährungsinvestoren`,
		mainpage_advantage_assetsecurity: `Kettenübergreifende Asset-Sicherheit`,
		mainpage_advantage_assetsecurity_details: `Ihre Assets sind sicher an intelligente Verträge gebunden, die Mehrfachsignaturen über alle Superknoten hinweg erfordern, um Transaktionen abzuschließen.`,
		mainpage_advantage_assetsecurity_details_1: `100% dezentralisiert, sodass nur Sie mit Ihrem privaten Schlüssel Zugriff auf Ihre Assets haben.`,
		mainpage_advantage_tradingspeed: `Blitz-Handelsgeschwindigkeit`,
		mainpage_advantage_tradingspeed_details: `Unser fortschrittlicher Blockchain-Konsensus-Mechanismus erzielt eine überragende Leistung und Sicherheit, während Bestellungen innerhalb von 3 Sekunden ausgeführt werden. Wertvolle Funktionen für alle Händler und Investoren.`,
		mainpage_advantage_crosschain: `Perfekter Kreuzkettenmechanismus`,
		mainpage_advantage_crosschain_details: `Die einzig wahre kettenübergreifende Lösung im dezentralen Handelssystem.`,
		mainpage_advantage_crosschain_details_1: `Wir unterstützen BTC、USDT(ERC20)、ETH 、CMT- und andere Mainstream-Blockchain-Assets. Wir bauen den Umfang Ihres Handels weiter aus.`,
		mainpage_advantage_globalarrangement: `Globale Anordnung`,
		mainpage_advantage_globalarrangement_details: `Um das ultimative Handelserlebnis für alle Benutzer auf der ganzen Welt zu gewährleisten, werden Superknoten in 8 Ländern auf 4 Kontinenten bereitgestellt.`,
		mainpage_advantage_kline: `Professionelles K-Line Anzeigetool`,
		mainpage_advantage_kline_details: `Unser professioneller Kundendienst steht Ihnen rund um die Uhr zur Verfügung.`,
		mainpage_latest_price: `Letzter Preis`,
		mainpage_change: `Veränderung`,
		c1: `Tokyo`,
		c2: `Virginia`,
		c3: `London`,
		c4: `Singapur`,
		c5: `Sydney`,
		c6: `Sao Paulo`,
		c7: `Kalifornien`,
		c8: `Seoul`,
		c9: `Frankfurt`,
		c10: `Ohio`,
		c11: `Oregon`,
		p1: `Tokyo`,
		p2: `Virginia`,
		p3: `London`,
		p4: `Singapur`,
		p5: `Sydney`,
		p6: `Sao Paulo`,
		p7: `Kalifornien`,
		p8: `Seoul`,
		p9: `Frankfurt`,
		p10: `Ohio`,
		p11: `Oregon`,
		en: `Englisch`,
		password: `Passwort`,
		confirmpw: `Passwort bestätigen`,
		signup: `ANMELDEN`,
		alreadysu: `Eingetragen?`,
		login: `ANMELDUNG`,
		signuptitle: `WILLKOMMEN BEI GATEWAYSTAR`,
		email: `Email`,
		signupwelcome: `WILLKOMMEN BEI GATEWAYSTAR`,
		confirm: `BESTÄTIGEN`,
		forgetpw: `Passwort vergessen`,
		passwordWrong: `Passwort mindestens 8 Zeichen und enthält englische Buchstaben und Zahlen`,
		emailWrong: `Ungültige E-Mail-Adresse`,
		loginWrong: `Falscher Emal oder falsches Passwort`,
		userExits: `E-Mail wird bereits beendet`,
		passwordIsSame: `Diese Passwörter stimmten nicht überein`,
		pleaseInputRightEmail: `Bitte geben Sie die richtige E-Mail ein`,
		success: `Erfolg`,
		invalid_referrer_info: `Ungültige Referrer-Informationen`,
		invalid_referrer_info_desc: `Dieses Empfehlungskonto kann nicht beendet werden. Stellen Sie sicher, dass der Empfehlungslink korrekt oder vollständig ist. Wenn Sie auf "Weiter zum Erstellen" klicken, werden die Empfehlungsinformationen nicht verwendet, um die Kontoerstellung abzuschließen. Bist du sicher, dass du weitermachen wirst?`,
		invalid_referrer_info_cancel: `Stornieren`,
		invalid_referrer_info_create: `Fahren Sie mit dem Erstellen fort`,
		input_the_type_and_account_name: `Geben Sie den {Typ} und den Kontonamen ein, getrennt durch Leerzeichen`,
        kyc_function_name: 'KYC',
        kyc_step1_title: 'Schritt 1',
        kyc_step1_subtitle: 'Überprüfen Sie die Informationen',
        kyc_step2_title: 'Schritt 2',
        kyc_step2_subtitle: 'Identitätsbild hochladen',
        kyc_step1_field1_title: 'Überprüfen Sie die Telefonnummer',
        kyc_step1_field1_content1: 'Geben Sie Ihre Telefonnummer ein',
        kyc_step1_field1_content2: '6 Digitaler Code',
        kyc_step1_field1_content3: 'SMS-Code senden',
        kyc_step1_field1_content4: 'Erneut senden',
        kyc_step1_field2_title: 'Email Adresse bestätigen',
        kyc_step1_field2_content1: 'Geben sie ihre E-Mailadresse ein',
        kyc_step1_field2_content2: '6 Digitaler Code',
        kyc_step1_field2_content3: 'E-Mail senden',
        kyc_step1_field2_content4: 'Erneut senden',
        kyc_step1_confirm_button: 'BESTÄTIGEN',
        kyc_step2_field1_title: 'Vorname',
        kyc_step2_field1_content: 'Vorname',
        kyc_step2_field2_title: 'Nachname',
        kyc_step2_field2_content: 'Nachname',
        kyc_step2_field3_title: 'Identitätstyp',
        kyc_step2_field3_content1: 'Personalausweis',
        kyc_step2_field3_content2: 'Reisepass',
        kyc_step2_field3_content3: 'Fahrerlaubnis',
        kyc_step2_field4_title: 'Dokumentnummer',
        kyc_step2_field4_content: 'Geben Sie die Identifikationsnummer ein',
        kyc_step2_field5_title: 'Identitätsdokument hochladen',
        kyc_step2_field5_subtitle: '* Bitte stellen Sie sicher, dass das Foto und der Text klar sind, da dies sonst die Überprüfung beeinträchtigen kann',
        kyc_step2_field5_content1: 'Klicken Sie hier, um das vordere Foto des Dokuments hochzuladen',
        kyc_step2_field5_content2: 'Klicken Sie hier, um das hintere Foto des Dokuments hochzuladen',
        kyc_step2_field5_content3: 'Klicken Sie hier, um ein Selfie mit der Vorderseite des Ausweisdokuments hochzuladen',
        kyc_step2_field5_content4_1: 'Klicken Sie hier, um einen gültigen Adressnachweis hochzuladen, der jünger als 3 Monate ist',
        kyc_step2_field5_content4_2: 'ein. Stromrechnungen (Strom, Gas, Wasser usw.); \n b. Festnetz-Telefonrechnung; \n c. Kreditkarte oder Kontoauszug',
        kyc_status_processing: 'Ihre ID-Informationen werden überprüft',
        kyc_status_succeed: 'Ihre ID-Informationen wurden überprüft.',
        kyc_status_fail: 'Ihre Identitätsüberprüfung ist fehlgeschlagen',
        kyc_status_content1: 'Dokument Nr.',
        kyc_status_content2: 'Grund',
    },
	fr: {
		fr: `Français`,
		trade_orderbook_sellorbuy: `vendre acheter`,
		trade_orderbook_sellorbuy_price: `Prix`,
		trade_orderbook_sellorbuy_amount: `Montant`,
		trade_orderbook_sellorbuy_sum: `Somme`,
		trade_orderbook_sell: `Vendre`,
		trade_orderbook_sell_price: `Prix`,
		trade_orderbook_sell_amount: `Montant`,
		trade_orderbook_sell_sum: `Somme`,
		trade_orderbook_buy: `Acheter`,
		trade_orderbook_buy_price: `Prix`,
		trade_orderbook_buy_amount: `Montant`,
		trade_orderbook_buy_sum: `Somme`,
		trade_orderbook_decimals: `décimales`,
		trade_markettrades: `Métiers du marché`,
		trade_markettrades_price: `Prix`,
		trade_markettrades_amount: `Montant`,
		trade_markettrades_sum: `Somme`,
		trade_tradezone_limit: `Limite`,
		trade_tradezone_limit_price: `Prix`,
		trade_tradezone_limit_amount: `Montant`,
		trade_tradezone_limit_buy: `Acheter`,
		trade_tradezone_limit_sell: `Vendre`,
		trade_tradezone_market: `Marché`,
		trade_tradezone_market_price: `Prix`,
		trade_tradezone_market_amount: `Montant`,
		trade_tradezone_market_buy: `Acheter`,
		trade_tradezone_market_sell: `Vendre`,
		trade_chart_kline: `Kline`,
		trade_chart_depth: `Profondeur`,
		trade_order_openorder: `Commande ouverte`,
		trade_order_orderhistory: `Historique des commandes`,
		trade_order_deals: `Offres`,
		Theamountislessthantheminimum: `Le montant est inférieur au minimum`,
		trade_order_hideotherpairs: `Masquer les autres paires`,
		trade_amount_is_greater_than_the_balance: `Le montant est supérieur au solde`,
		trade_cancel_order_success: `Annuler le succès de la commande`,
		trade_the_best_market_pricde: `Le meilleur prix du marché`,
		trade_balance_not_enough: `Équilibre pas assez`,
		balance_account_username: `Nom d\'utilisateur`,
		balance_account_password: `Mot de passe`,
		balance_account_repeatpassword: `Répéter le mot de passe`,
		balance_account_confirm: `CONFIRMER`,
		delete_account: `Compte de déconnexion`,
		delete_account_tips1: `Veuillez noter que vous vous déconnectez des informations de compte, veillez à bien sauvegarder la clé mnémonique ou privée de ce compte, sinon vous`,
		delete_account_tips2: `sera définitivement incapable d\'accéder à ce compte`,
		delete_account_tips3: `entraînant une perte d’actifs. La clé mnémonique et la clé privée ne peuvent être sauvegardées que manuellement et l'échange ne peut pas les récupérer.`,
		delete_account_tips4: `Après avoir cliqué pour confirmer, entrez le mot de passe en suivant l'invite, le système téléchargera automatiquement un fichier mnémonique. Veuillez le sauvegarder correctement.`,
		delete_account_tips5: `Attention`,
		delete_account_tips6: `Conseils`,
		delete_account_confirm: `CONFIRMER LA DÉCONNEXION`,
		account_logout: `Se déconnecter`,
		balance_mnemonics_ihavereadthiswarning: `J\'ai lu cet avertissement`,
		balance_mnemonics_complete: `Achevée`,
		balance_mnemonics_previous: `PRÉCÉDENT`,
		balance_mnemonics_confirm: `CONFIRMER`,
		balance_history: `Histoire`,
		balance_history_deposithistory: `Histoire de dépôt`,
		balance_history_deposithistory_time: `Temps`,
		balance_history_deposithistory_asset: `Atout`,
		balance_history_deposithistory_amount: `Montant`,
		balance_history_deposithistory_status: `Statut`,
		balance_history_deposithistory_action: `action`,
		balance_history_deposithistory_action_details: `Détails`,
		balance_history_withdrawhistory: `Retirer l\'historique`,
		balance_history_withdrawhistory_time: `Temps`,
		balance_history_withdrawhistory_asset: `Atout`,
		balance_history_withdrawhistory_amount: `Montant`,
		balance_history_withdrawhistory_status: `Statut`,
		balance_history_withdrawhistory_action: `action`,
		balance_history_withdrawhistory_action_details: `Détails`,
		balance_history_transferhistory: `Historique de transfert`,
		balance_fiat_transferhistory: `Histoire Fiat`,
		balance_history_transferhistory_time: `Temps`,
		balance_history_transferhistory_asset: `Atout`,
		balance_history_transferhistory_amount: `Montant`,
		balance_history_transferhistory_status: `Statut`,
		balance_history_transferhistory_action: `action`,
		balance_history_transferhistory_action_details: `Détails`,
		balance_view_on_explorer: `vue sur l\'explorateur`,
		balance_balancezone_hide0balance: `Masquer 0 solde`,
		balance_balancezone_search: `Chercher`,
		balance_balancezone_symbol: `symbole`,
		balance_balancezone_balance: `Équilibre`,
		balance_balancezone_freeze: `Geler`,
		balance_balancezone_available: `Disponible`,
		balance_balancezone_action: `action`,
		balance_balancezone_transfer: `Transfert`,
		balance_balancezone_transfer_to: `À`,
		balance_balancezone_transfer_receiversaccount: `compte destinataire`,
		balance_balancezone_transfer_amount: `Montant`,
		balance_balancezone_transfer_typeamount: `type montant`,
		balance_balancezone_transfer_message: `Message`,
		balance_balancezone_transfer_cancel: `Annuler`,
		balance_balancezone_transfer_confirm: `Confirmer`,
		balance_balancezone_deposit: `Dépôt`,
		balance_balancezone_deposit_copy: `Copie`,
		balance_balancezone_withdraw: `Se désister`,
		balance_balancezone_fiat_out: `FiatOut`,
		balance_balancezone_withdraw_address: `Adresse`,
		balance_balancezone_withdraw_inputyourwithdrawaddress: `entrez votre adresse de retrait`,
		balance_balancezone_withdraw_amount: `Montant`,
		balance_balancezone_withdraw_typeamount: `type montant`,
		balance_balancezone_withdraw_confirm: `Confirmer`,
		balance_copy_success: `Copier le succès!`,
		balance_please_input_address_and_amount: `S'il vous plaît entrer l'adresse et le montant!`,
		balance_successful_withdraw: `Retrait réussi`,
		orders_ordersrecord_openorders: `Commandes ouvertes`,
		balance_withdraw_address: `Retirer l\'adresse`,
		orders_ordersrecord_openorders_time: `Temps`,
		orders_ordersrecord_openorders_market: `Marché`,
		orders_ordersrecord_openorders_side: `Côté`,
		orders_ordersrecord_openorders_price: `Prix`,
		orders_ordersrecord_openorders_amount: `Montant`,
		orders_ordersrecord_openorders_total: `Total`,
		orders_ordersrecord_openorders_filled: `Rempli%`,
		orders_ordersrecord_openorders_action: `action`,
		orders_ordersrecord_orderhistory: `Historique des commandes`,
		orders_ordersrecord_orderhistory_time: `Temps`,
		orders_ordersrecord_orderhistory_market: `Marché`,
		orders_ordersrecord_orderhistory_side: `Côté`,
		orders_ordersrecord_orderhistory_price: `Prix`,
		orders_ordersrecord_orderhistory_amount: `Montant`,
		orders_ordersrecord_orderhistory_total: `Total`,
		orders_ordersrecord_orderhistory_filled: `Rempli%`,
		orders_ordersrecord_orderhistory_action: `action`,
		orders_ordersrecord_deals: `Offres`,
		orders_ordersrecord_deals_time: `Temps`,
		orders_ordersrecord_deals_market: `Marché`,
		orders_ordersrecord_deals_side: `Côté`,
		orders_ordersrecord_deals_price: `Prix`,
		orders_ordersrecord_deals_amount: `Montant`,
		orders_ordersrecord_deals_total: `Total`,
		orders_ordersrecord_deals_filled: `Rempli%`,
		orders_ordersrecord_deals_action: `action`,
		nav_trade: `Commerce`,
		nav_balance: `Équilibre`,
		nav_orders: `Ordres`,
		nav_faq: `questions - réponses`,
		nav_fiat: `Décret`,
		nav_explorer: `Explorateur`,
		nav_country_virginia: `Virginie`,
		nav_country_singapore: `Singapour`,
		nav_language_english: `Anglais`,
		nav_create: `Créer`,
		nav_create_username: `Nom d\'utilisateur`,
		nav_create_password: `Mot de passe`,
		nav_create_repeatpassword: `Répéter le mot de passe`,
		nav_create_confirm: `CONFIRMER`,
		nav_create_back: `Retour`,
		nav_or: `OU`,
		nav_import: `Importation`,
		nav_import_bymnemonics: `Par mnémoniques`,
		nav_import_typeyourmnemonics: `Tapez vos mnémoniques`,
		nav_import_entermnemonics: `Entrez les mnémoniques`,
		nav_import_password: `Mot de passe`,
		nav_import_enterpassword: `Entrer le mot de passe`,
		nav_import_repeatpassword: `Répéter le mot de passe`,
		nav_import_reenterpassword: `Retaper le mot de passe`,
		nav_import_byprivatekey: `Par clé privée`,
		nav_import_typeyourprivatekey: `Tapez votre clé privée`,
		nav_import_enterprivatekey: `Entrer une clé privée`,
		nav_import_confirm: `CONFIRMER`,
		nav_import_createaccount: `créer un compte`,
		nav_import_back: `Retour`,
		account_copy: `Copie`,
		account_view: `Vue`,
		account_export: `Exportation`,
		account_export_verifypassword: `vérifier le mot de passe`,
		account_export_entersomething: `Entrez quelque chose`,
		account_export_confirm: `CONFIRMER`,
		account_switchaccount: `Changer de compte`,
		account_createnewaccount: `Créer un nouveau compte`,
		account_importaccount: `Compte d\'importation`,
		account_createasset: `Créer un actif`,
		account_createmarket: `Créer un marché`,
		account_what_is_mnomenics: `Qu\'est-ce que la ménomique?`,
		footer_ecology: `Écologie`,
		footer_ecology_bytetradeblockchain: `Bytetrade Blockchain`,
		footer_ecology_downloadclients: `Télécharger les clients`,
		footer_ecology_pitiopaymentprotocal: `Protocole de paiement PITIO`,
		footer_support: `Soutien`,
		footer_support_createaccount: `Créer un compte`,
		footer_support_deposit: `Dépôt`,
		footer_support_withdraw: `Se désister`,
		footer_support_fees: `Honoraires`,
		footer_support_fee: `Frais`,
		footer_support_more: `Plus`,
		footer_contact: `Contact`,
		footer_contact_listtoken: `ListToken`,
		footer_socialmedia: `Des médias sociaux`,
		footer_mediakit_telegram: `Télégramme`,
		footer_mediakit_facebook: `Facebook`,
		footer_mediakit_twitter: `Twitter`,
		footer_mediakit_medium: `Moyen`,
		trade_high: `Haute`,
		trade_low: `Faible`,
		trade_volume: `Le volume`,
		trade_change: `Changement`,
		trade_turnover: `Rotation`,
		trade_coin_name: `Pièce de monnaie`,
		trade_set_price_field_to_current_highest_ask: `Définir le champ de prix sur la demande la plus basse`,
		trade_set_price_field_to_current_highest_bid: `Définir le champ de prix sur l\'offre la plus élevée en cours`,
		trade_set_price_field_to_current_low_ask: `Définir le champ de prix sur la demande la plus basse`,
		trade_set_price_field_to_current_low_bid: `Définir le champ de prix sur l\'offre la plus basse en cours`,
		trade_chart: `Graphique`,
		trade_order_submitted: `Commande soumise`,
		trade_amount_can_not_be_empty: `montant ne peut pas être vide`,
		trade_input_is_invaild: `l\'entrée est invoquée`,
		trade_the_balance_is_not_enough: `La disponibilité n\'est pas suffisante`,
		trade_next: `Prochain`,
		trade_prev: `Prev`,
		trade_no_record: `Aucun enregistrement`,
		trade_amount_is_too_small: `Le montant est trop petit`,
		trade_market_price_error: `La soumission a échoué car elle n’a pas de prix sur le marché.`,
		trade_market_price: `Prix ​​du marché`,
		account_only_3_steps_it_won_t_take_much_longer: `Seulement 3 étapes, cela ne prendra pas beaucoup plus longtemps`,
		acccount_important: `Important`,
		account_back_your_account: `Retournez votre compte`,
		account_do_not_forge: `N\'OUBLIEZ PAS`,
		account_to_save_your_mnomenics_you_will_need_this: `pour sauver votre mnomenics. Vous aurez besoin de cela`,
		account_confirm_mnemonic: `Confirmer mnémonique`,
		account_fill_in_the_blanks_to_ensure_the_backup_is_correct: `Remplissez les espaces pour vous assurer que la sauvegarde est correcte`,
		account_user_name_is_invaild: `Le nom d\'utilisateur est invoqué`,
		account_password_not_satisfied: `mot de passe ne correspond pas`,
		account_i_have_read_this_warning: `J\'ai lu cet avertissement`,
		account_byteTrade_is_a_decentralized_system: ` est un système décentralisé. Si vous perdez les informations de votre compte sur cet ordinateur, nous sommes désolés de ne pas pouvoir les récupérer.`,
		account_do_it_later: `Fais-le plus tard`,
		account_please_agree_the_anouncement_below: `Veuillez accepter l\'annonce ci-dessous`,
		//nottrans: ``,
		account_welcome_back: `Nous saluons le retour`,
		account_by_mnemonics: `Par mnémoniques`,
		account_by_private_key: `Par clé privée`,
		account_type_your: `Tapez votre`,
		account_type_mnemonics: `mnémotechnique`,
		account_enter: `Entrer`,
		account_enter_password: `Entrer le mot de passe...`,
		account_repeat_password: `Répéter le mot de passe`,
		account_re_enter_password: `Retaper le mot de passe...`,
		account_or: `OU`,
		account_crete_account: `Compte Crète`,
		account_private_key: `Clé privée`,
		account_mnomenics_error: `Erreur Mnomenics`,
		account_mnemonics_cannot_be_empty: `les mnémoniques ne peuvent pas être vides`,
		account_password_cannot_be_empty: `mot de passe ne peut pas être vide`,
		account_password_unsame: `mot de passe différent du mot de passe reepat`,
		account_username_is_already_exist: `nom d\'utilisateur existe déjà`,
		account_input_the_password: `entrez le mot de passe`,
		account_mnomenics_was_incorrect: `Mnomenics était incorrect`,
		account_password_wrong: `Mot de passe faux`,
		account_username_not_exist: `Ce nom de compte dosen \ t existe sur notre blockchain`,
		account_mnemonics_length_error: `erreur de longueur des mnémoniques`,
		account_username_already_exist: `nom d\'utilisateur existe déjà`,
		account_username_invaild: `nom d\'utilisateur invaild`,
		account_password_error: `erreur de mot de passe`,
		account_fail_transfer: `échec du transfert`,
		balance_estimated_value: `Valeur estimée`,
		balance_input_your_message: `Entrez votre message ici`,
		balance_deposit_address: `Adresse de dépôt`,
		balance_scan_this_qr_code: `Scannez ce code QR`,
		balance_please_go_to: `S\'il vous plaît allez à`,
		balance_view_Progress: `voir les progrès`,
		balance_do_not_deposit_any_non_eth_assets_to_this_address: `Ne déposez aucun actif non {actif} à cette adresse.`,
		balance_min_deposit_amount: `Montant du dépôt minimum`,
		balance_min_withdraw_amount: `Montant minimum de retrait`,
		balance_be_sure_to_check_the_security: `Assurez-vous de vérifier la sécurité de votre ordinateur et de votre navigateur pour éviter toute falsification ou fuite d'informations.`,
		balance_successful_transfer: `transfert réussi`,
		balance_please_input_valid_address: `Veuillez entrer une adresse valide {asset}`,
		order_no_more: `Pas plus`,
		order_this_is_last_page: `c\'est la dernière page`,
		history_process_time: `Temps de traitement`,
		history_transaction: `Transaction`,
		mainpage_banner_tatle: `Plateforme de trading crypto-monnaie professionnelle, sécurisée et transparente`,
		mainpage_advantage_title: `La plateforme de trading décentralisée la plus importante au monde`,
		mainpage_advantage_subtitle: `Fournir des services de trading d\'actifs sûrs, stables et efficaces aux investisseurs professionnels mondiaux de la crypto-monnaie`,
		mainpage_advantage_assetsecurity: `Sécurité des actifs entre chaînes`,
		mainpage_advantage_assetsecurity_details: `Vos actifs sont verrouillés de manière sécurisée dans des contrats intelligents nécessitant plusieurs signatures sur tous les super nœuds pour mener à bien les transactions.`,
		mainpage_advantage_assetsecurity_details_1: `100% décentralisé pour que vous ayez seul accès à vos actifs à l\'aide de votre clé privée.`,
		mainpage_advantage_tradingspeed: `Vitesse de négociation éclair`,
		mainpage_advantage_tradingspeed_details: `Notre mécanisme de consensus de blockchain avancé assure des performances et une sécurité supérieures tout en complétant les commandes en moins de 3 secondes. Caractéristiques précieuses pour tous les commerçants et investisseurs.`,
		mainpage_advantage_crosschain: `Mécanisme de cross-chaîne parfait`,
		mainpage_advantage_crosschain_details: `La seule véritable solution inter-chaînes dans le système commercial décentralisé.`,
		mainpage_advantage_crosschain_details_1: `Nous soutenons les BTC、USDT(ERC20)、ETH 、CMT et autres actifs blockchain traditionnels. Nous continuons à développer la portée de vos échanges.`,
		mainpage_advantage_globalarrangement: `Arrangement global`,
		mainpage_advantage_globalarrangement_details: `Afin de garantir une expérience de trading ultime pour tous les utilisateurs du monde entier, des super nœuds sont déployés dans 8 pays sur 4 continents.`,
		mainpage_advantage_kline: `Indicateur professionnel K-line`,
		mainpage_advantage_kline_details: `Notre support client professionnel est disponible 24h / 24 et 7j / 7.`,
		mainpage_latest_price: `Dernier prix`,
		mainpage_change: `Changement`,
		c1: `Tokyo`,
		c2: `Virginie`,
		c3: `Londres`,
		c4: `Singapour`,
		c5: `Sydney`,
		c6: `Sao Paulo`,
		c7: `Californie`,
		c8: `Séoul`,
		c9: `Francfort`,
		c10: `Ohio`,
		c11: `Oregon`,
		p1: `Tokyo`,
		p2: `Virginie`,
		p3: `Londres`,
		p4: `Singapour`,
		p5: `Sydney`,
		p6: `Sao Paulo`,
		p7: `Californie`,
		p8: `Séoul`,
		p9: `Francfort`,
		p10: `Ohio`,
		p11: `Oregon`,
		en: `Anglais`,
		password: `Mot de passe`,
		confirmpw: `Confirmez le mot de passe`,
		signup: `S\'INSCRIRE`,
		alreadysu: `Inscrit?`,
		login: `S\'IDENTIFIER`,
		signuptitle: `BIENVENUE À GATEWAYSTAR`,
		email: `Email`,
		signupwelcome: `BIENVENUE À GATEWAYSTAR`,
		confirm: `CONFIRMER`,
		forgetpw: `Mot de passe oublié`,
		passwordWrong: `Mot de passe d\'au moins 8 caractères et contenant des lettres et des chiffres en anglais`,
		emailWrong: `Adresse e-mail invalide`,
		loginWrong: `Mauvais emal ou mot de passe`,
		userExits: `Le courrier électronique existe déjà`,
		passwordIsSame: `Ces mots de passe ne correspondaient pas`,
		pleaseInputRightEmail: `S\'il vous plaît entrer le bon email`,
		success: `Succès`,
		invalid_referrer_info: `Information de référent invalide`,
		invalid_referrer_info_desc: `Ce compte de référence existe déjà, assurez-vous que le lien de référence est correct ou complet. Cliquer sur "Continuer pour créer" n'utilisera pas les informations de renvoi pour terminer la création du compte. Êtes-vous sûr de continuer?`,
		invalid_referrer_info_cancel: `Annuler`,
		invalid_referrer_info_create: `Continuer à créer`,
		input_the_type_and_account_name: `Entrez le {type} et le nom du compte, séparés par des espaces`,
        kyc_function_name: 'KYC',
        kyc_step1_title: 'Étape 1',
        kyc_step1_subtitle: 'Vérifier les informations',
        kyc_step2_title: 'Étape 2',
        kyc_step2_subtitle: 'Télécharger une image d\'identité',
        kyc_step1_field1_title: 'Vérifier le numéro de téléphone',
        kyc_step1_field1_content1: 'Entrez votre numéro de téléphone',
        kyc_step1_field1_content2: '6 code numérique',
        kyc_step1_field1_content3: 'Envoyer un code SMS',
        kyc_step1_field1_content4: 'Renvoyer',
        kyc_step1_field2_title: 'Vérifier l\'adresse e-mail',
        kyc_step1_field2_content1: 'Entrez votre adresse e-mail',
        kyc_step1_field2_content2: '6 code numérique',
        kyc_step1_field2_content3: 'Envoyer un email',
        kyc_step1_field2_content4: 'Renvoyer',
        kyc_step1_confirm_button: 'CONFIRMER',
        kyc_step2_field1_title: 'Prénom',
        kyc_step2_field1_content: 'Prénom',
        kyc_step2_field2_title: 'Nom de famille',
        kyc_step2_field2_content: 'Nom de famille',
        kyc_step2_field3_title: 'Type d\'identité',
        kyc_step2_field3_content1: 'Carte d\'identité nationale',
        kyc_step2_field3_content2: 'Passeport',
        kyc_step2_field3_content3: 'Permis de conduire',
        kyc_step2_field4_title: 'numéro de document',
        kyc_step2_field4_content: 'Entrez le numéro d\'identité',
        kyc_step2_field5_title: 'Télécharger le document d\'identité',
        kyc_step2_field5_subtitle: '* S\'il vous plaît assurez-vous que la photo et le texte sont clairs, sinon cela pourrait affecter la révision',
        kyc_step2_field5_content1: 'Cliquez pour télécharger la photo avant du document',
        kyc_step2_field5_content2: 'Cliquer pour télécharger la photo arrière du document',
        kyc_step2_field5_content3: 'Cliquez pour télécharger un selfie contenant le recto de la pièce d\'identité',
        kyc_step2_field5_content4_1: 'Cliquez pour télécharger un certificat d\'adresse valide, valide pour une durée maximale de 3 mois.',
        kyc_step2_field5_content4_2: 'une. Factures de services publics (électricité, gaz, eau, etc.); \n b. Facture de téléphone fixe; \n c. Carte de crédit ou relevé bancaire',
        kyc_status_processing: 'Vos informations d\'identification sont en cours de révision',
        kyc_status_succeed: 'Vos informations d\'identification ont été vérifiées.',
        kyc_status_fail: 'Votre vérification d\'identité a échoué',
        kyc_status_content1: 'numéro de document',
        kyc_status_content2: 'Raison',

    },
	pl: {
		pl: `Polskie`,
    	trade_orderbook_sellorbuy: `sprzedać kupić`,
		trade_orderbook_sellorbuy_price: `Cena £`,
		trade_orderbook_sellorbuy_amount: `Ilość`,
		trade_orderbook_sellorbuy_sum: `Suma`,
		trade_orderbook_sell: `Sprzedać`,
		trade_orderbook_sell_price: `Cena £`,
		trade_orderbook_sell_amount: `Ilość`,
		trade_orderbook_sell_sum: `Suma`,
		trade_orderbook_buy: `Kupować`,
		trade_orderbook_buy_price: `Cena £`,
		trade_orderbook_buy_amount: `Ilość`,
		trade_orderbook_buy_sum: `Suma`,
		trade_orderbook_decimals: `miejsca po przecinku`,
		trade_markettrades: `Transakcje rynkowe`,
		trade_markettrades_price: `Cena £`,
		trade_markettrades_amount: `Ilość`,
		trade_markettrades_sum: `Suma`,
		trade_tradezone_limit: `Limit`,
		trade_tradezone_limit_price: `Cena £`,
		trade_tradezone_limit_amount: `Ilość`,
		trade_tradezone_limit_buy: `Kupować`,
		trade_tradezone_limit_sell: `Sprzedać`,
		trade_tradezone_market: `Rynek`,
		trade_tradezone_market_price: `Cena £`,
		trade_tradezone_market_amount: `Ilość`,
		trade_tradezone_market_buy: `Kupować`,
		trade_tradezone_market_sell: `Sprzedać`,
		trade_chart_kline: `Kline`,
		trade_chart_depth: `Głębokość`,
		trade_order_openorder: `Otwórz zamówienie`,
		trade_order_orderhistory: `Historia zamówień`,
		trade_order_deals: `Oferty`,
		Theamountislessthantheminimum: `Kwota jest mniejsza niż minimum`,
		trade_order_hideotherpairs: `Ukryj inne pary`,
		trade_amount_is_greater_than_the_balance: `Kwota jest większa niż saldo`,
		trade_cancel_order_success: `Anuluj zamówienie zakończone powodzeniem`,
		trade_the_best_market_pricde: `Najlepsza cena rynkowa`,
		trade_balance_not_enough: `Równowaga nie wystarcza`,
		balance_account_username: `Nazwa Użytkownika`,
		balance_account_password: `Hasło`,
		balance_account_repeatpassword: `Powtórz hasło`,
		balance_account_confirm: `POTWIERDZAĆ`,
		delete_account: `Wyloguj się`,
		delete_account_tips1: `Pamiętaj, że wylogowujesz się z informacji o koncie, należy wykonać kopię zapasową mnemonicznego lub prywatnego klucza tego konta, w przeciwnym razie`,
		delete_account_tips2: `na stałe nie będzie mieć dostępu do tego konta`,
		delete_account_tips3: `powodując utratę aktywów. Kopię zapasową klucza mnemonicznego i prywatnego można wykonać tylko ręcznie, a giełda nie może go odzyskać.`,
		delete_account_tips4: `Po kliknięciu w celu potwierdzenia wprowadź hasło zgodnie z poleceniem, system automatycznie pobierze plik mnemoniczny, proszę zapisać go poprawnie.`,
		delete_account_tips5: `Ostrzeżenie`,
		delete_account_tips6: `Napiwki`,
		delete_account_confirm: `POTWIERDŹ WYLOG`,
		account_logout: `Wyloguj`,
		balance_mnemonics_ihavereadthiswarning: `Przeczytałem to ostrzeżenie`,
		balance_mnemonics_complete: `Kompletny`,
		balance_mnemonics_previous: `POPRZEDNI`,
		balance_mnemonics_confirm: `POTWIERDZAĆ`,
		balance_history: `Historia`,
		balance_history_deposithistory: `Historia depozytów`,
		balance_history_deposithistory_time: `Czas`,
		balance_history_deposithistory_asset: `Kapitał`,
		balance_history_deposithistory_amount: `Ilość`,
		balance_history_deposithistory_status: `Status`,
		balance_history_deposithistory_action: `Akcja`,
		balance_history_deposithistory_action_details: `Detale`,
		balance_history_withdrawhistory: `Wycofaj historię`,
		balance_history_withdrawhistory_time: `Czas`,
		balance_history_withdrawhistory_asset: `Kapitał`,
		balance_history_withdrawhistory_amount: `Ilość`,
		balance_history_withdrawhistory_status: `Status`,
		balance_history_withdrawhistory_action: `Akcja`,
		balance_history_withdrawhistory_action_details: `Detale`,
		balance_history_transferhistory: `Historia transferów`,
		balance_fiat_transferhistory: `Historia Fiata`,
		balance_history_transferhistory_time: `Czas`,
		balance_history_transferhistory_asset: `Kapitał`,
		balance_history_transferhistory_amount: `Ilość`,
		balance_history_transferhistory_status: `Status`,
		balance_history_transferhistory_action: `Akcja`,
		balance_history_transferhistory_action_details: `Detale`,
		balance_view_on_explorer: `zobacz w odkrywcy`,
		balance_balancezone_hide0balance: `Ukryj saldo 0`,
		balance_balancezone_search: `Szukaj`,
		balance_balancezone_symbol: `Symbol`,
		balance_balancezone_balance: `Saldo`,
		balance_balancezone_freeze: `Zamrażać`,
		balance_balancezone_available: `Dostępny`,
		balance_balancezone_action: `Akcja`,
		balance_balancezone_transfer: `Transfer`,
		balance_balancezone_transfer_to: `Do`,
		balance_balancezone_transfer_receiversaccount: `konto odbiorcy`,
		balance_balancezone_transfer_amount: `Ilość`,
		balance_balancezone_transfer_typeamount: `wpisz kwotę`,
		balance_balancezone_transfer_message: `Wiadomość`,
		balance_balancezone_transfer_cancel: `anulować`,
		balance_balancezone_transfer_confirm: `Potwierdzać`,
		balance_balancezone_deposit: `Kaucja`,
		balance_balancezone_deposit_copy: `Kopiuj`,
		balance_balancezone_withdraw: `Wycofać`,
		balance_balancezone_fiat_out: `FiatOut`,
		balance_balancezone_withdraw_address: `Adres`,
		balance_balancezone_withdraw_inputyourwithdrawaddress: `wpisz swój adres do wypłaty`,
		balance_balancezone_withdraw_amount: `Ilość`,
		balance_balancezone_withdraw_typeamount: `wpisz kwotę`,
		balance_balancezone_withdraw_confirm: `Potwierdzać`,
		balance_copy_success: `Skopiuj sukces!`,
		balance_please_input_address_and_amount: `Podaj adres i kwotę!`,
		balance_successful_withdraw: `Pomyślne wycofanie`,
		orders_ordersrecord_openorders: `Otwarte zlecenia`,
		balance_withdraw_address: `Wycofaj adres`,
		orders_ordersrecord_openorders_time: `Czas`,
		orders_ordersrecord_openorders_market: `Rynek`,
		orders_ordersrecord_openorders_side: `Bok`,
		orders_ordersrecord_openorders_price: `Cena £`,
		orders_ordersrecord_openorders_amount: `Ilość`,
		orders_ordersrecord_openorders_total: `Całkowity`,
		orders_ordersrecord_openorders_filled: `Wypełniony%`,
		orders_ordersrecord_openorders_action: `Akcja`,
		orders_ordersrecord_orderhistory: `Historia zamówień`,
		orders_ordersrecord_orderhistory_time: `Czas`,
		orders_ordersrecord_orderhistory_market: `Rynek`,
		orders_ordersrecord_orderhistory_side: `Bok`,
		orders_ordersrecord_orderhistory_price: `Cena £`,
		orders_ordersrecord_orderhistory_amount: `Ilość`,
		orders_ordersrecord_orderhistory_total: `Całkowity`,
		orders_ordersrecord_orderhistory_filled: `Wypełniony%`,
		orders_ordersrecord_orderhistory_action: `Akcja`,
		orders_ordersrecord_deals: `Oferty`,
		orders_ordersrecord_deals_time: `Czas`,
		orders_ordersrecord_deals_market: `Rynek`,
		orders_ordersrecord_deals_side: `Bok`,
		orders_ordersrecord_deals_price: `Cena £`,
		orders_ordersrecord_deals_amount: `Ilość`,
		orders_ordersrecord_deals_total: `Całkowity`,
		orders_ordersrecord_deals_filled: `Wypełniony%`,
		orders_ordersrecord_deals_action: `Akcja`,
		nav_trade: `Handel, zawód`,
		nav_balance: `Saldo`,
		nav_orders: `Zamówienia`,
		nav_faq: `FAQ`,
		nav_fiat: `Placet`,
		nav_explorer: `poszukiwacz`,
		nav_country_virginia: `Virginia`,
		nav_country_singapore: `Singapur`,
		nav_language_english: `język angielski`,
		nav_create: `Stwórz`,
		nav_create_username: `Nazwa Użytkownika`,
		nav_create_password: `Hasło`,
		nav_create_repeatpassword: `Powtórz hasło`,
		nav_create_confirm: `POTWIERDZAĆ`,
		nav_create_back: `Plecy`,
		nav_or: `LUB`,
		nav_import: `Import`,
		nav_import_bymnemonics: `Przez mnemoniki`,
		nav_import_typeyourmnemonics: `Wpisz swoje mnemoniki`,
		nav_import_entermnemonics: `Wpisz mnemoniki`,
		nav_import_password: `Hasło`,
		nav_import_enterpassword: `Wprowadź hasło`,
		nav_import_repeatpassword: `Powtórz hasło`,
		nav_import_reenterpassword: `Wprowadź ponownie hasło`,
		nav_import_byprivatekey: `Według klucza prywatnego`,
		nav_import_typeyourprivatekey: `Wpisz swój klucz prywatny`,
		nav_import_enterprivatekey: `Wpisz klucz prywatny`,
		nav_import_confirm: `POTWIERDZAĆ`,
		nav_import_createaccount: `Utwórz konto`,
		nav_import_back: `Plecy`,
		account_copy: `Kopiuj`,
		account_view: `Widok`,
		account_export: `Eksport`,
		account_export_verifypassword: `Zweryfikuj hasło`,
		account_export_entersomething: `Wpisz coś`,
		account_export_confirm: `POTWIERDZAĆ`,
		account_switchaccount: `Przełącz konto`,
		account_createnewaccount: `Stwórz nowe konto`,
		account_importaccount: `Importuj konto`,
		account_createasset: `Utwórz zasób`,
		account_createmarket: `Utwórz rynek`,
		account_what_is_mnomenics: `Co to jest Mnomenics?`,
		footer_ecology: `Ekologia`,
		footer_ecology_bytetradeblockchain: `Blockchain Bytetrade`,
		footer_ecology_downloadclients: `Pobierz klientów`,
		footer_ecology_pitiopaymentprotocal: `Protokół płatności PITIO`,
		footer_support: `Wsparcie`,
		footer_support_createaccount: `Utwórz konto`,
		footer_support_deposit: `Kaucja`,
		footer_support_withdraw: `Wycofać`,
		footer_support_fees: `Opłaty`,
		footer_support_fee: `Opłata`,
		footer_support_more: `Więcej`,
		footer_contact: `Kontakt`,
		footer_contact_listtoken: `ListToken`,
		footer_socialmedia: `Media społecznościowe`,
		footer_mediakit_telegram: `Telegram`,
		footer_mediakit_facebook: `Facebook`,
		footer_mediakit_twitter: `Świergot`,
		footer_mediakit_medium: `Średni`,
		trade_high: `Wysoki`,
		trade_low: `Niska`,
		trade_volume: `Tom`,
		trade_change: `Zmiana`,
		trade_turnover: `Obrót handlowy`,
		trade_coin_name: `Moneta`,
		trade_set_price_field_to_current_highest_ask: `Ustaw pole ceny na bieżące najniższe zapytanie`,
		trade_set_price_field_to_current_highest_bid: `Ustaw pole ceny na bieżącą najwyższą ofertę`,
		trade_set_price_field_to_current_low_ask: `Ustaw pole ceny na bieżące najniższe zapytanie`,
		trade_set_price_field_to_current_low_bid: `Ustaw pole ceny na bieżącą najniższą ofertę`,
		trade_chart: `Wykres`,
		trade_order_submitted: `Złożone zamówienie`,
		trade_amount_can_not_be_empty: `kwota nie może być pusta`,
		trade_input_is_invaild: `wejście jest dostępne`,
		trade_the_balance_is_not_enough: `Dostępne to za mało`,
		trade_next: `Kolejny`,
		trade_prev: `Poprz`,
		trade_no_record: `Brak zapisu`,
		trade_amount_is_too_small: `Kwota jest zbyt mała`,
		trade_market_price_error: `Przesyłanie nie powiodło się, ponieważ nie ma ceny na rynku.`,
		trade_market_price: `Cena rynkowa`,
		account_only_3_steps_it_won_t_take_much_longer: `Tylko 3 kroki, nie potrwa to dłużej`,
		acccount_important: `Ważny`,
		account_back_your_account: `Wróć swoje konto`,
		account_do_not_forge: `NIE ZAPOMNIJ`,
		account_to_save_your_mnomenics_you_will_need_this: `aby zapisać swoją mnomenikę. Będziesz tego potrzebować`,
		account_confirm_mnemonic: `Potwierdź mnemonik`,
		account_fill_in_the_blanks_to_ensure_the_backup_is_correct: `Wypełnij puste pola, aby upewnić się, że kopia zapasowa jest poprawna`,
		account_user_name_is_invaild: `Nazwa użytkownika jest dostępna`,
		account_password_not_satisfied: `hasło nie pasuje`,
		account_i_have_read_this_warning: `Przeczytałem to ostrzeżenie`,
		account_byteTrade_is_a_decentralized_system: ` to system zdecentralizowany. Jeśli utracisz informacje o koncie z tego komputera, przykro nam, że nie możemy go odzyskać.`,
		account_do_it_later: `Zrobić to później`,
		account_please_agree_the_anouncement_below: `Proszę uzgodnić ogłoszenie poniżej`,
		//nottrans: ``,
		account_welcome_back: `Witamy spowrotem`,
		account_by_mnemonics: `Przez mnemoniki`,
		account_by_private_key: `Według klucza prywatnego`,
		account_type_your: `Wpisz swój`,
		account_type_mnemonics: `mnemonika`,
		account_enter: `Wchodzić`,
		account_enter_password: `Wprowadź hasło...`,
		account_repeat_password: `Powtórz hasło`,
		account_re_enter_password: `Wprowadź ponownie hasło...`,
		account_or: `LUB`,
		account_crete_account: `Konto na Krecie`,
		account_private_key: `Prywatny klucz`,
		account_mnomenics_error: `Błąd mechaniki`,
		account_mnemonics_cannot_be_empty: `mnemoniki nie mogą być puste`,
		account_password_cannot_be_empty: `hasło nie może być puste`,
		account_password_unsame: `hasło nie równe powtórz hasło`,
		account_username_is_already_exist: `nazwa użytkownika już istnieje`,
		account_input_the_password: `wprowadź hasło`,
		account_mnomenics_was_incorrect: `Mnomenika była niepoprawna`,
		account_password_wrong: `Nieprawidłowe hasło`,
		account_username_not_exist: `Ta nazwa konta nie istnieje w naszym blockchainie`,
		account_mnemonics_length_error: `błąd długości mnemoniki`,
		account_username_already_exist: `Nazwa użytkownika już istnieje`,
		account_username_invaild: `nazwa użytkownika dostępna`,
		account_password_error: `błędne hasło`,
		account_fail_transfer: `nieudany transfer`,
		balance_estimated_value: `Przewidywana wartość`,
		balance_input_your_message: `Wpisz tutaj swoją wiadomość`,
		balance_deposit_address: `Adres wpłaty`,
		balance_scan_this_qr_code: `Zeskanuj ten kod QR`,
		balance_please_go_to: `Proszę idź do`,
		balance_view_Progress: `zobacz postęp`,
		balance_do_not_deposit_any_non_eth_assets_to_this_address: `Nie deponuj żadnych zasobów innych niż {asset} na ten adres`,
		balance_min_deposit_amount: `Minimalna kwota depozytu`,
		balance_min_withdraw_amount: `Minimalna kwota wypłaty`,
		balance_be_sure_to_check_the_security: `Należy sprawdzić bezpieczeństwo komputera i przeglądarki, aby zapobiec manipulowaniu lub wyciekowi informacji`,
		balance_successful_transfer: `udany transfer`,
		balance_please_input_valid_address: `Podaj prawidłowy adres {asset}`,
		order_no_more: `już nie`,
		order_this_is_last_page: `to jest ostatnia strona`,
		history_process_time: `Czas przetwarzania`,
		history_transaction: `Transakcja`,
		mainpage_banner_tatle: `Profesjonalna, bezpieczna i przejrzysta platforma handlu kryptowalutami`,
		mainpage_advantage_title: `Wiodąca na świecie zdecentralizowana platforma handlu kryptowalutami`,
		mainpage_advantage_subtitle: `Zapewnienie bezpiecznych, stabilnych i wydajnych usług handlu aktywami globalnym profesjonalnym inwestorom kryptowalut`,
		mainpage_advantage_assetsecurity: `Zabezpieczenia aktywów między łańcuchami`,
		mainpage_advantage_assetsecurity_details: `Twoje aktywa są bezpiecznie zablokowane w inteligentnych umowach wymagających wielu podpisów we wszystkich super węzłach do realizacji transakcji.`,
		mainpage_advantage_assetsecurity_details_1: `W 100% zdecentralizowany, więc tylko Ty masz dostęp do swoich zasobów za pomocą klucza prywatnego.`,
		mainpage_advantage_tradingspeed: `Błyskawiczna prędkość handlu`,
		mainpage_advantage_tradingspeed_details: `Nasz zaawansowany mechanizm konsensusu blockchain osiąga najwyższą wydajność i bezpieczeństwo podczas realizacji zamówień w ciągu 3 sekund. Cenne funkcje dla wszystkich traderów i inwestorów.`,
		mainpage_advantage_crosschain: `Idealny mechanizm krzyżowy`,
		mainpage_advantage_crosschain_details: `Jedyne prawdziwe rozwiązanie krzyżowe w zdecentralizowanym systemie obrotu.`,
		mainpage_advantage_crosschain_details_1: `Obsługujemy BTC、USDT(ERC20)、ETH 、CMT i inne główne aktywa blockchain. Nadal budujemy zakres twojego handlu.`,
		mainpage_advantage_globalarrangement: `Porozumienie globalne`,
		mainpage_advantage_globalarrangement_details: `Aby zapewnić najwyższą jakość handlu wszystkim użytkownikom na całym świecie, superwęzły są wdrażane w 8 krajach na 4 kontynentach.`,
		mainpage_advantage_kline: `Profesjonalne narzędzie wskaźnika K-line`,
		mainpage_advantage_kline_details: `Nasza profesjonalna obsługa klienta jest dostępna 24/7.`,
		mainpage_latest_price: `Najnowsza cena`,
		mainpage_change: `Zmiana`,
		c1: `Tokio`,
		c2: `Virginia`,
		c3: `Londyn`,
		c4: `Singapur`,
		c5: `Sydnej`,
		c6: `San Paulo`,
		c7: `Kalifornia`,
		c8: `Seul`,
		c9: `Frankfurt`,
		c10: `Ohio`,
		c11: `Oregon`,
		p1: `Tokio`,
		p2: `Virginia`,
		p3: `Londyn`,
		p4: `Singapur`,
		p5: `Sydnej`,
		p6: `San Paulo`,
		p7: `Kalifornia`,
		p8: `Seul`,
		p9: `Frankfurt`,
		p10: `Ohio`,
		p11: `Oregon`,
		en: `język angielski`,
		password: `Hasło`,
		confirmpw: `Potwierdź hasło`,
		signup: `ZAPISZ SIĘ`,
		alreadysu: `Zarejestrowany?`,
		login: `ZALOGUJ SIE`,
		signuptitle: `WITAMY W GATEWAYSTAR`,
		email: `E-mail`,
		signupwelcome: `WITAMY W GATEWAYSTAR`,
		confirm: `POTWIERDZAĆ`,
		forgetpw: `Zapomniałeś hasła`,
		passwordWrong: `Hasło składa się z co najmniej 8 znaków i zawiera angielskie litery i cyfry`,
		emailWrong: `Niepoprawny adres email`,
		loginWrong: `Zły emal lub hasło`,
		userExits: `E-mail już wychodzi`,
		passwordIsSame: `Te hasła nie pasowały`,
		pleaseInputRightEmail: `Podaj poprawny adres e-mail`,
		success: `Powodzenie`,
		invalid_referrer_info: `Nieprawidłowe informacje o polecającym`,
		invalid_referrer_info_desc: `To konto polecające nie wychodzi, upewnij się, że link polecający jest poprawny lub kompletny. Kliknięcie przycisku „Kontynuuj tworzenie” nie wykorzysta informacji o poleceniu do ukończenia tworzenia konta. Czy na pewno będziesz kontynuować?`,
		invalid_referrer_info_cancel: `anulować`,
		invalid_referrer_info_create: `Kontynuuj tworzenie`,
		input_the_type_and_account_name: `Wpisz {typ} i nazwę konta oddzielone spacjami`,
        kyc_function_name: 'KYC',
        kyc_step1_title: 'Krok 1',
        kyc_step1_subtitle: 'Zweryfikuj informacje',
        kyc_step2_title: 'Krok 2',
        kyc_step2_subtitle: 'Prześlij obraz tożsamości',
        kyc_step1_field1_title: 'Zweryfikuj numer telefonu',
        kyc_step1_field1_content1: 'Wpisz swój numer telefonu',
        kyc_step1_field1_content2: '6 Kod cyfrowy',
        kyc_step1_field1_content3: 'Wyślij kod SMS',
        kyc_step1_field1_content4: 'Wysłać ponownie',
        kyc_step1_field2_title: 'Zweryfikuj adres e-mail',
        kyc_step1_field2_content1: 'Wpisz swój adres e-mail',
        kyc_step1_field2_content2: '6 Kod cyfrowy',
        kyc_step1_field2_content3: 'Wysłać email',
        kyc_step1_field2_content4: 'Wysłać ponownie',
        kyc_step1_confirm_button: 'POTWIERDZAĆ',
        kyc_step2_field1_title: 'Imię',
        kyc_step2_field1_content: 'Imię',
        kyc_step2_field2_title: 'Nazwisko',
        kyc_step2_field2_content: 'Nazwisko',
        kyc_step2_field3_title: 'Rodzaj tożsamości',
        kyc_step2_field3_content1: 'Narodowa karta identyfikacyjna',
        kyc_step2_field3_content2: 'Paszport',
        kyc_step2_field3_content3: 'Prawo jazdy',
        kyc_step2_field4_title: 'Numer dokumentu',
        kyc_step2_field4_content: 'Wprowadź numer identyfikacyjny',
        kyc_step2_field5_title: 'Prześlij dokument tożsamości',
        kyc_step2_field5_subtitle: '* Upewnij się, że zdjęcie i tekst są wyraźne, w przeciwnym razie może to wpłynąć na recenzję',
        kyc_step2_field5_content1: 'Kliknij, aby przesłać zdjęcie z przodu dokumentu',
        kyc_step2_field5_content2: 'Kliknij, aby przesłać tylne zdjęcie dokumentu',
        kyc_step2_field5_content3: 'Kliknij, aby przesłać selfie z trzymaniem przodu dokumentu tożsamości',
        kyc_step2_field5_content4_1: 'Kliknij, aby przesłać ważny dowód adresu, który jest starszy niż 3 miesiące',
        kyc_step2_field5_content4_2: 'za. Rachunki za media (prąd, gaz, woda itp.); \n b. Rachunek za telefon stacjonarny; \n c. Wyciąg z karty kredytowej lub bankowej',
        kyc_status_processing: 'Twoje dane identyfikacyjne są sprawdzane',
        kyc_status_succeed: 'Twoje dane identyfikacyjne zostały zweryfikowane.',
        kyc_status_fail: 'Twoja weryfikacja tożsamości nie powiodła się',
        kyc_status_content1: 'Dokument numer.',
        kyc_status_content2: 'Powód',
    },
	ja: {
		ja: `日本语`,
		trade_orderbook_sellorbuy: `売買`,
		trade_orderbook_sellorbuy_price: `価格`,
		trade_orderbook_sellorbuy_amount: `量`,
		trade_orderbook_sellorbuy_sum: `和`,
		trade_orderbook_sell: `売る`,
		trade_orderbook_sell_price: `価格`,
		trade_orderbook_sell_amount: `量`,
		trade_orderbook_sell_sum: `和`,
		trade_orderbook_buy: `購入`,
		trade_orderbook_buy_price: `価格`,
		trade_orderbook_buy_amount: `量`,
		trade_orderbook_buy_sum: `和`,
		trade_orderbook_decimals: `小数`,
		trade_markettrades: `市場取引`,
		trade_markettrades_price: `価格`,
		trade_markettrades_amount: `量`,
		trade_markettrades_sum: `和`,
		trade_tradezone_limit: `限定`,
		trade_tradezone_limit_price: `価格`,
		trade_tradezone_limit_amount: `量`,
		trade_tradezone_limit_buy: `購入`,
		trade_tradezone_limit_sell: `売る`,
		trade_tradezone_market: `市場`,
		trade_tradezone_market_price: `価格`,
		trade_tradezone_market_amount: `量`,
		trade_tradezone_market_buy: `購入`,
		trade_tradezone_market_sell: `売る`,
		trade_chart_kline: `クライン`,
		trade_chart_depth: `深さ`,
		trade_order_openorder: `注文を開く`,
		trade_order_orderhistory: `注文履歴`,
		trade_order_deals: `取引`,
		Theamountislessthantheminimum: `金額が最小額より少ない`,
		trade_order_hideotherpairs: `他のペアを非表示`,
		trade_amount_is_greater_than_the_balance: `金額が残高より多い`,
		trade_cancel_order_success: `注文のキャンセルを成功させる`,
		trade_the_best_market_pricde: `最高の市場価格`,
		trade_balance_not_enough: `バランスが十分ではありません`,
		balance_account_username: `ユーザー名`,
		balance_account_password: `パスワード`,
		balance_account_repeatpassword: `パスワードを再度入力してください`,
		balance_account_confirm: `確認する`,
		delete_account: `ログアウトアカウント`,
		delete_account_tips1: `アカウント情報からログアウトしていることに注意してください。このアカウントのニーモニックキーまたは秘密キーを必ずバックアップしてください。`,
		delete_account_tips2: `このアカウントに永久にアクセスできなくなります`,
		delete_account_tips3: `資産の損失をもたらします。ニーモニックキーと秘密キーは手動でのみバックアップでき、交換機はそれを取得できません。`,
		delete_account_tips4: `クリックして確認し、プロンプトに従ってパスワードを入力すると、システムはニーモニックファイルを自動的にダウンロードします。適切に保存してください。`,
		delete_account_tips5: `警告`,
		delete_account_tips6: `ヒント`,
		delete_account_confirm: `ログアウトの確認`,
		account_logout: `ログアウト`,
		balance_mnemonics_ihavereadthiswarning: `この警告を読みました`,
		balance_mnemonics_complete: `コンプリート`,
		balance_mnemonics_previous: `前`,
		balance_mnemonics_confirm: `確認する`,
		balance_history: `歴史`,
		balance_history_deposithistory: `入金履歴`,
		balance_history_deposithistory_time: `時間`,
		balance_history_deposithistory_asset: `資産`,
		balance_history_deposithistory_amount: `量`,
		balance_history_deposithistory_status: `状態`,
		balance_history_deposithistory_action: `アクション`,
		balance_history_deposithistory_action_details: `詳細`,
		balance_history_withdrawhistory: `履歴を撤回する`,
		balance_history_withdrawhistory_time: `時間`,
		balance_history_withdrawhistory_asset: `資産`,
		balance_history_withdrawhistory_amount: `量`,
		balance_history_withdrawhistory_status: `状態`,
		balance_history_withdrawhistory_action: `アクション`,
		balance_history_withdrawhistory_action_details: `詳細`,
		balance_history_transferhistory: `転送履歴`,
		balance_fiat_transferhistory: `フィアットの歴史`,
		balance_history_transferhistory_time: `時間`,
		balance_history_transferhistory_asset: `資産`,
		balance_history_transferhistory_amount: `量`,
		balance_history_transferhistory_status: `状態`,
		balance_history_transferhistory_action: `アクション`,
		balance_history_transferhistory_action_details: `詳細`,
		balance_view_on_explorer: `エクスプローラーで表示`,
		balance_balancezone_hide0balance: `0バランスを非表示`,
		balance_balancezone_search: `調べる`,
		balance_balancezone_symbol: `シンボル`,
		balance_balancezone_balance: `残高`,
		balance_balancezone_freeze: `フリーズ`,
		balance_balancezone_available: `利用可能`,
		balance_balancezone_action: `アクション`,
		balance_balancezone_transfer: `転送`,
		balance_balancezone_transfer_to: `に`,
		balance_balancezone_transfer_receiversaccount: `受取人口座`,
		balance_balancezone_transfer_amount: `量`,
		balance_balancezone_transfer_typeamount: `タイプ量`,
		balance_balancezone_transfer_message: `メッセージ`,
		balance_balancezone_transfer_cancel: `キャンセル`,
		balance_balancezone_transfer_confirm: `確認する`,
		balance_balancezone_deposit: `保証金`,
		balance_balancezone_deposit_copy: `コピー`,
		balance_balancezone_withdraw: `撤回`,
		balance_balancezone_fiat_out: `FiatOut`,
		balance_balancezone_withdraw_address: `住所`,
		balance_balancezone_withdraw_inputyourwithdrawaddress: `引き出しアドレスを入力してください`,
		balance_balancezone_withdraw_amount: `量`,
		balance_balancezone_withdraw_typeamount: `タイプ量`,
		balance_balancezone_withdraw_confirm: `確認する`,
		balance_copy_success: `コピー成功！`,
		balance_please_input_address_and_amount: `住所と金額を入力してください！`,
		balance_successful_withdraw: `成功した引き出し`,
		orders_ordersrecord_openorders: `未処理の注文`,
		balance_withdraw_address: `出金アドレス`,
		orders_ordersrecord_openorders_time: `時間`,
		orders_ordersrecord_openorders_market: `市場`,
		orders_ordersrecord_openorders_side: `側`,
		orders_ordersrecord_openorders_price: `価格`,
		orders_ordersrecord_openorders_amount: `量`,
		orders_ordersrecord_openorders_total: `合計`,
		orders_ordersrecord_openorders_filled: `いっぱい％`,
		orders_ordersrecord_openorders_action: `アクション`,
		orders_ordersrecord_orderhistory: `注文履歴`,
		orders_ordersrecord_orderhistory_time: `時間`,
		orders_ordersrecord_orderhistory_market: `市場`,
		orders_ordersrecord_orderhistory_side: `側`,
		orders_ordersrecord_orderhistory_price: `価格`,
		orders_ordersrecord_orderhistory_amount: `量`,
		orders_ordersrecord_orderhistory_total: `合計`,
		orders_ordersrecord_orderhistory_filled: `いっぱい％`,
		orders_ordersrecord_orderhistory_action: `アクション`,
		orders_ordersrecord_deals: `取引`,
		orders_ordersrecord_deals_time: `時間`,
		orders_ordersrecord_deals_market: `市場`,
		orders_ordersrecord_deals_side: `側`,
		orders_ordersrecord_deals_price: `価格`,
		orders_ordersrecord_deals_amount: `量`,
		orders_ordersrecord_deals_total: `合計`,
		orders_ordersrecord_deals_filled: `いっぱい％`,
		orders_ordersrecord_deals_action: `アクション`,
		nav_trade: `トレード`,
		nav_balance: `残高`,
		nav_orders: `ご注文`,
		nav_faq: `よくある質問`,
		nav_fiat: `フィアット`,
		nav_explorer: `冒険者`,
		nav_country_virginia: `バージニア`,
		nav_country_singapore: `シンガポール`,
		nav_language_english: `英語`,
		nav_create: `作成する`,
		nav_create_username: `ユーザー名`,
		nav_create_password: `パスワード`,
		nav_create_repeatpassword: `パスワードを再度入力してください`,
		nav_create_confirm: `確認する`,
		nav_create_back: `バック`,
		nav_or: `または`,
		nav_import: `インポート`,
		nav_import_bymnemonics: `ニーモニック`,
		nav_import_typeyourmnemonics: `ニーモニックを入力します`,
		nav_import_entermnemonics: `ニーモニックを入力`,
		nav_import_password: `パスワード`,
		nav_import_enterpassword: `パスワードを入力する`,
		nav_import_repeatpassword: `パスワードを再度入力してください`,
		nav_import_reenterpassword: `パスワード再入力`,
		nav_import_byprivatekey: `秘密鍵で`,
		nav_import_typeyourprivatekey: `秘密鍵を入力してください`,
		nav_import_enterprivatekey: `秘密鍵を入力してください`,
		nav_import_confirm: `確認する`,
		nav_import_createaccount: `アカウントを作成する`,
		nav_import_back: `バック`,
		account_copy: `コピー`,
		account_view: `見る`,
		account_export: `書き出す`,
		account_export_verifypassword: `パスワードを照合します`,
		account_export_entersomething: `何かを入力してください`,
		account_export_confirm: `確認する`,
		account_switchaccount: `アカウントを切り替える`,
		account_createnewaccount: `新しいアカウントを作成する`,
		account_importaccount: `アカウントをインポート`,
		account_createasset: `アセットを作成`,
		account_createmarket: `マーケットを作成`,
		account_what_is_mnomenics: `名詞`,
		footer_ecology: `エコロジー`,
		footer_ecology_bytetradeblockchain: `バイトトレードブロックチェーン`,
		footer_ecology_downloadclients: `クライアントをダウンロードする`,
		footer_ecology_pitiopaymentprotocal: `PITIO支払いプロトコル`,
		footer_support: `サポート`,
		footer_support_createaccount: `アカウントを作成する`,
		footer_support_deposit: `保証金`,
		footer_support_withdraw: `撤回`,
		footer_support_fees: `料金`,
		footer_support_fee: `費用`,
		footer_support_more: `もっと`,
		footer_contact: `接触`,
		footer_contact_listtoken: `ListToken`,
		footer_socialmedia: `ソーシャルメディア`,
		footer_mediakit_telegram: `電報`,
		footer_mediakit_facebook: `フェイスブック`,
		footer_mediakit_twitter: `ツイッター`,
		footer_mediakit_medium: `中`,
		trade_high: `高い`,
		trade_low: `低い`,
		trade_volume: `ボリューム`,
		trade_change: `変化する`,
		trade_turnover: `売上高`,
		trade_coin_name: `コイン`,
		trade_set_price_field_to_current_highest_ask: `価格フィールドを現在の最低売値に設定します`,
		trade_set_price_field_to_current_highest_bid: `価格フィールドを現在の最高入札価格に設定する`,
		trade_set_price_field_to_current_low_ask: `価格フィールドを現在の最低売値に設定します`,
		trade_set_price_field_to_current_low_bid: `価格フィールドを現在の最低入札価格に設定します`,
		trade_chart: `チャート`,
		trade_order_submitted: `発注済み`,
		trade_amount_can_not_be_empty: `金額は空にできません`,
		trade_input_is_invaild: `入力が無効です`,
		trade_the_balance_is_not_enough: `利用可能は十分ではありません`,
		trade_next: `次`,
		trade_prev: `前の`,
		trade_no_record: `記録なし`,
		trade_amount_is_too_small: `金額が少なすぎる`,
		trade_market_price_error: `市場に価格がないため、送信に失敗しました。`,
		trade_market_price: `市場価格`,
		account_only_3_steps_it_won_t_take_much_longer: `わずか3ステップ、それ以上長くかかりません`,
		acccount_important: `重要`,
		account_back_your_account: `アカウントをバックアップする`,
		account_do_not_forge: `忘れないで`,
		account_to_save_your_mnomenics_you_will_need_this: `あなたの名詞を保存します。これが必要になります`,
		account_confirm_mnemonic: `ニーモニックを確認`,
		account_fill_in_the_blanks_to_ensure_the_backup_is_correct: `空白を埋めて、バックアップが正しいことを確認します`,
		account_user_name_is_invaild: `ユーザー名が無効です`,
		account_password_not_satisfied: `パスワードが一致しません`,
		account_i_have_read_this_warning: `この警告を読みました`,
		account_byteTrade_is_a_decentralized_system: `は分散システムです。このコンピューターからアカウント情報を紛失した場合、取得できず申し訳ありません。`,
		account_do_it_later: `後でやる`,
		account_please_agree_the_anouncement_below: `以下の発表に同意してください`,
		//nottrans: ``,
		account_welcome_back: `お帰りなさい`,
		account_by_mnemonics: `ニーモニック`,
		account_by_private_key: `秘密鍵で`,
		account_type_your: `あなたのタイプ`,
		account_type_mnemonics: `ニーモニック`,
		account_enter: `入る`,
		account_enter_password: `パスワードを入力する...`,
		account_repeat_password: `パスワードを再度入力してください`,
		account_re_enter_password: `パスワード再入力...`,
		account_or: `または`,
		account_crete_account: `クレタ島のアカウント`,
		account_private_key: `秘密鍵`,
		account_mnomenics_error: `名詞エラー`,
		account_mnemonics_cannot_be_empty: `ニーモニックは空にできません`,
		account_password_cannot_be_empty: `パスワードは空にできません`,
		account_password_unsame: `パスワードが再パスワードと等しくない`,
		account_username_is_already_exist: `ユーザー名は既に存在します`,
		account_input_the_password: `パスワードを入力してください`,
		account_mnomenics_was_incorrect: `名詞は間違っていた`,
		account_password_wrong: `パスワードが間違っています`,
		account_username_not_exist: `このアカウント名は、ブロックチェーンに存在しません`,
		account_mnemonics_length_error: `ニーモニック長エラー`,
		account_username_already_exist: `ユーザー名は既に存在します`,
		account_username_invaild: `ユーザー名が無効です`,
		account_password_error: `パスワードエラー`,
		account_fail_transfer: `失敗した転送`,
		balance_estimated_value: `推定値`,
		balance_input_your_message: `ここにメッセージを入力してください`,
		balance_deposit_address: `入金先住所`,
		balance_scan_this_qr_code: `このQRコードをスキャン`,
		balance_please_go_to: `に行ってください`,
		balance_view_Progress: `進捗を見る`,
		balance_do_not_deposit_any_non_eth_assets_to_this_address: `この住所に{資産}以外の資産を預けないでください`,
		balance_min_deposit_amount: `最低入金額`,
		balance_min_withdraw_amount: `最低出金額`,
		balance_be_sure_to_check_the_security: `情報の改ざんや漏洩を防ぐため、コンピューターとブラウザーのセキュリティを必ず確認してください。`,
		balance_successful_transfer: `転送成功`,
		balance_please_input_valid_address: `有効な{asset}アドレスを入力してください`,
		order_no_more: `もういや`,
		order_this_is_last_page: `これは最後のページです`,
		history_process_time: `処理時間`,
		history_transaction: `トランザクション`,
		mainpage_banner_tatle: `プロフェッショナルで安全かつ透明な暗号通貨取引プラットフォーム`,
		mainpage_advantage_title: `世界をリードする暗号通貨分散型取引プラットフォーム`,
		mainpage_advantage_subtitle: `世界のプロ暗号通貨投資家に安全で安定した効率的な資産取引サービスを提供する`,
		mainpage_advantage_assetsecurity: `クロスチェーン資産セキュリティ`,
		mainpage_advantage_assetsecurity_details: `資産はスマートコントラクトに安全にロックされ、トランザクションを完了するためにすべてのスーパーノードで複数の署名が必要です。`,
		mainpage_advantage_assetsecurity_details_1: `100％分散化されているため、プライベートキーを使用してアセットにアクセスできます。`,
		mainpage_advantage_tradingspeed: `雷取引速度`,
		mainpage_advantage_tradingspeed_details: `高度なブロックチェーンコンセンサスメカニズムにより、優れたパフォーマンスとセキュリティを実現しながら、3秒以内に注文を完了します。すべてのトレーダーと投資家にとって貴重な機能。`,
		mainpage_advantage_crosschain: `完璧なクロスチェーン機構`,
		mainpage_advantage_crosschain_details: `分散型取引システムで唯一の真のクロスチェーンソリューション。`,
		mainpage_advantage_crosschain_details_1: `BTC、USDT(ERC20)、ETH 、CMT、およびその他の主流のブロックチェーン資産をサポートしています。私たちはあなたの取引の範囲を構築し続けます。`,
		mainpage_advantage_globalarrangement: `グローバル配置`,
		mainpage_advantage_globalarrangement_details: `世界中のすべてのユーザーに究極の取引体験を保証するために、4つの大陸の8か国にスーパーノードが展開されています。`,
		mainpage_advantage_kline: `プロフェッショナルKラインインジケーターツール`,
		mainpage_advantage_kline_details: `弊社のプロフェッショナルカスタマーサポートは年中無休でご利用いただけます。`,
		mainpage_latest_price: `最新の価格`,
		mainpage_change: `変化する`,
		c1: `東京`,
		c2: `バージニア`,
		c3: `ロンドン`,
		c4: `シンガポール`,
		c5: `シドニー`,
		c6: `サンパウロ`,
		c7: `カリフォルニア`,
		c8: `ソウル`,
		c9: `フランクフルト`,
		c10: `オハイオ`,
		c11: `オレゴン`,
		p1: `東京`,
		p2: `バージニア`,
		p3: `ロンドン`,
		p4: `シンガポール`,
		p5: `シドニー`,
		p6: `サンパウロ`,
		p7: `カリフォルニア`,
		p8: `ソウル`,
		p9: `フランクフルト`,
		p10: `オハイオ`,
		p11: `オレゴン`,
		en: `英語`,
		password: `パスワード`,
		confirmpw: `パスワードを認証する`,
		signup: `サインアップ`,
		alreadysu: `登録済みですか？`,
		login: `ログインする`,
		signuptitle: `ゲートウェイスターへようこそ`,
		email: `Eメール`,
		signupwelcome: `ゲートウェイスターへようこそ`,
		confirm: `確認する`,
		forgetpw: `パスワードを忘れましたか`,
		passwordWrong: `パスワードは8文字以上で、英語の文字と数字が含まれています`,
		emailWrong: `無効なメールアドレス`,
		loginWrong: `間違ったエマールまたはパスワード`,
		userExits: `メールは既に終了しています`,
		passwordIsSame: `それらのパスワードは一致しませんでした`,
		pleaseInputRightEmail: `正しいメールアドレスを入力してください`,
		success: `成功`,
		invalid_referrer_info: `無効なリファラー情報`,
		invalid_referrer_info_desc: `この紹介アカウントは削除されました。紹介リンクが正しいか完全であることを確認してください。[作成を続行]をクリックしても、紹介情報を使用してアカウントの作成は完了しません。続行しますか？`,
		invalid_referrer_info_cancel: `キャンセル`,
		invalid_referrer_info_create: `作成を続ける`,
		input_the_type_and_account_name: `{type}とアカウント名をスペースで区切って入力してください`,
        kyc_function_name: 'KYC',
        kyc_step1_title: 'ステップ1',
        kyc_step1_subtitle: '情報を確認する',
        kyc_step2_title: 'ステップ2',
        kyc_step2_subtitle: 'アイデンティティ画像をアップロード',
        kyc_step1_field1_title: '電話番号を確認',
        kyc_step1_field1_content1: '電話番号を入力してください',
        kyc_step1_field1_content2: '6デジタルコード',
        kyc_step1_field1_content3: 'SMSコードを送信',
        kyc_step1_field1_content4: '再送信',
        kyc_step1_field2_title: 'メールアドレスの確認',
        kyc_step1_field2_content1: 'メールアドレスを入力してください',
        kyc_step1_field2_content2: '6デジタルコード',
        kyc_step1_field2_content3: 'メールを送る',
        kyc_step1_field2_content4: '再送信',
        kyc_step1_confirm_button: '確認する',
        kyc_step2_field1_title: 'ファーストネーム',
        kyc_step2_field1_content: 'ファーストネーム',
        kyc_step2_field2_title: '苗字',
        kyc_step2_field2_content: '苗字',
        kyc_step2_field3_title: 'アイデンティティータイプ',
        kyc_step2_field3_content1: '国民IDカード',
        kyc_step2_field3_content2: 'パスポート',
        kyc_step2_field3_content3: '運転免許証',
        kyc_step2_field4_title: '書類番号',
        kyc_step2_field4_content: '識別番号を入力してください',
        kyc_step2_field5_title: '身分証明書のアップロード',
        kyc_step2_field5_subtitle: '*写真とテキストが明確であることを確認してください。そうでないと、レビューに影響する可能性があります',
        kyc_step2_field5_content1: 'クリックしてドキュメントの正面写真をアップロードします',
        kyc_step2_field5_content2: 'クリックしてドキュメントの背面写真をアップロードします',
        kyc_step2_field5_content3: 'クリックして、身分証明書の前面を保持する自撮りをアップロードします',
        kyc_step2_field5_content4_1: 'クリックして3か月未満の有効な住所証明をアップロードします',
        kyc_step2_field5_content4_2: 'a。公共料金（電気、ガス、水道など）; \n b。固定電話の請求書; \n c。クレジットカードまたは銀行取引明細書',
        kyc_status_processing: 'あなたのID情報は審査中です',
        kyc_status_succeed: 'ID情報が確認されました。',
        kyc_status_fail: '本人確認に失敗しました',
        kyc_status_content1: '文書番号。',
        kyc_status_content2: '理由',
    },
	vi: {
		vi: "Tiếng Việt",
		trade_orderbook_sellorbuy: `mua bán`,
		trade_orderbook_sellorbuy_price: `Giá bán`,
		trade_orderbook_sellorbuy_amount: `Số tiền`,
		trade_orderbook_sellorbuy_sum: `Tổng`,
		trade_orderbook_sell: `Bán`,
		trade_orderbook_sell_price: `Giá bán`,
		trade_orderbook_sell_amount: `Số tiền`,
		trade_orderbook_sell_sum: `Tổng`,
		trade_orderbook_buy: `Mua`,
		trade_orderbook_buy_price: `Giá bán`,
		trade_orderbook_buy_amount: `Số tiền`,
		trade_orderbook_buy_sum: `Tổng`,
		trade_orderbook_decimals: `số thập phân`,
		trade_markettrades: `Giao dịch thị trường`,
		trade_markettrades_price: `Giá bán`,
		trade_markettrades_amount: `Số tiền`,
		trade_markettrades_sum: `Tổng`,
		trade_tradezone_limit: `Giới hạn`,
		trade_tradezone_limit_price: `Giá bán`,
		trade_tradezone_limit_amount: `Số tiền`,
		trade_tradezone_limit_buy: `Mua`,
		trade_tradezone_limit_sell: `Bán`,
		trade_tradezone_market: `Thị trường`,
		trade_tradezone_market_price: `Giá bán`,
		trade_tradezone_market_amount: `Số tiền`,
		trade_tradezone_market_buy: `Mua`,
		trade_tradezone_market_sell: `Bán`,
		trade_chart_kline: `Kline`,
		trade_chart_depth: `Chiều sâu`,
		trade_order_openorder: `Đặt hàng mở`,
		trade_order_orderhistory: `lịch sử đơn hàng`,
		trade_order_deals: `Ưu đãi`,
		Theamountislessthantheminimum: `Số tiền ít hơn mức tối thiểu`,
		trade_order_hideotherpairs: `Ẩn các cặp khác`,
		trade_amount_is_greater_than_the_balance: `Số tiền lớn hơn số dư`,
		trade_cancel_order_success: `Hủy đơn hàng thành công`,
		trade_the_best_market_pricde: `Giá thị trường tốt nhất`,
		trade_balance_not_enough: `Số dư không đủ`,
		balance_account_username: `Tên tài khoản`,
		balance_account_password: `Mật khẩu`,
		balance_account_repeatpassword: `Lặp lại mật khẩu`,
		balance_account_confirm: `XÁC NHẬN`,
		delete_account: `Tài khoản đăng xuất`,
		delete_account_tips1: `Xin lưu ý rằng bạn đang đăng xuất khỏi thông tin tài khoản, vui lòng đảm bảo sao lưu khóa ghi nhớ hoặc khóa riêng của tài khoản này, nếu không bạn`,
		delete_account_tips2: `sẽ vĩnh viễn không thể truy cập vào tài khoản này`,
		delete_account_tips3: `dẫn đến mất tài sản. Khóa riêng và ghi nhớ chỉ có thể được bạn sao lưu thủ công và trao đổi không thể truy xuất khóa.`,
		delete_account_tips4: `Sau khi nhấp để xác nhận, nhập mật khẩu theo lời nhắc, hệ thống sẽ tự động tải xuống một tệp ghi nhớ, vui lòng lưu lại đúng cách.`,
		delete_account_tips5: `Cảnh báo`,
		delete_account_tips6: `Lời khuyên`,
		delete_account_confirm: `ĐĂNG KÝ XÁC NHẬN`,
		account_logout: `Đăng xuất`,
		balance_mnemonics_ihavereadthiswarning: `Tôi đã đọc cảnh báo này`,
		balance_mnemonics_complete: `Hoàn thành`,
		balance_mnemonics_previous: `TRƯỚC`,
		balance_mnemonics_confirm: `XÁC NHẬN`,
		balance_history: `Lịch sử`,
		balance_history_deposithistory: `Lịch sử tiền gửi`,
		balance_history_deposithistory_time: `Thời gian`,
		balance_history_deposithistory_asset: `Tài sản`,
		balance_history_deposithistory_amount: `Số tiền`,
		balance_history_deposithistory_status: `Trạng thái`,
		balance_history_deposithistory_action: `Hoạt động`,
		balance_history_deposithistory_action_details: `Chi tiết`,
		balance_history_withdrawhistory: `Lịch sử rút tiền`,
		balance_history_withdrawhistory_time: `Thời gian`,
		balance_history_withdrawhistory_asset: `Tài sản`,
		balance_history_withdrawhistory_amount: `Số tiền`,
		balance_history_withdrawhistory_status: `Trạng thái`,
		balance_history_withdrawhistory_action: `Hoạt động`,
		balance_history_withdrawhistory_action_details: `Chi tiết`,
		balance_history_transferhistory: `Lịch sử chuyển nhượng`,
		balance_fiat_transferhistory: `Lịch sử Fiat`,
		balance_history_transferhistory_time: `Thời gian`,
		balance_history_transferhistory_asset: `Tài sản`,
		balance_history_transferhistory_amount: `Số tiền`,
		balance_history_transferhistory_status: `Trạng thái`,
		balance_history_transferhistory_action: `Hoạt động`,
		balance_history_transferhistory_action_details: `Chi tiết`,
		balance_view_on_explorer: `xem trên thám hiểm`,
		balance_balancezone_hide0balance: `Ẩn số dư 0`,
		balance_balancezone_search: `Tìm kiếm`,
		balance_balancezone_symbol: `Biểu tượng`,
		balance_balancezone_balance: `Thăng bằng`,
		balance_balancezone_freeze: `Đông cứng`,
		balance_balancezone_available: `Có sẵn`,
		balance_balancezone_action: `Hoạt động`,
		balance_balancezone_transfer: `chuyển khoản`,
		balance_balancezone_transfer_to: `Đến`,
		balance_balancezone_transfer_receiversaccount: `tài khoản người nhận`,
		balance_balancezone_transfer_amount: `Số tiền`,
		balance_balancezone_transfer_typeamount: `số lượng loại`,
		balance_balancezone_transfer_message: `Thông điệp`,
		balance_balancezone_transfer_cancel: `Hủy bỏ`,
		balance_balancezone_transfer_confirm: `Xác nhận`,
		balance_balancezone_deposit: `Tiền gửi`,
		balance_balancezone_deposit_copy: `Sao chép`,
		balance_balancezone_withdraw: `Rút tiền`,
		balance_balancezone_fiat_out: `FiatOut`,
		balance_balancezone_withdraw_address: `Địa chỉ nhà`,
		balance_balancezone_withdraw_inputyourwithdrawaddress: `nhập địa chỉ rút tiền của bạn`,
		balance_balancezone_withdraw_amount: `Số tiền`,
		balance_balancezone_withdraw_typeamount: `số lượng loại`,
		balance_balancezone_withdraw_confirm: `Xác nhận`,
		balance_copy_success: `Sao chép thành công!`,
		balance_please_input_address_and_amount: `Vui lòng nhập địa chỉ và số tiền!`,
		balance_successful_withdraw: `Rút tiền thành công`,
		orders_ordersrecord_openorders: `Đơn đặt hàng mở`,
		balance_withdraw_address: `Địa chỉ rút tiền`,
		orders_ordersrecord_openorders_time: `Thời gian`,
		orders_ordersrecord_openorders_market: `Thị trường`,
		orders_ordersrecord_openorders_side: `Bên`,
		orders_ordersrecord_openorders_price: `Giá bán`,
		orders_ordersrecord_openorders_amount: `Số tiền`,
		orders_ordersrecord_openorders_total: `Toàn bộ`,
		orders_ordersrecord_openorders_filled: `Đã điền%`,
		orders_ordersrecord_openorders_action: `Hoạt động`,
		orders_ordersrecord_orderhistory: `lịch sử đơn hàng`,
		orders_ordersrecord_orderhistory_time: `Thời gian`,
		orders_ordersrecord_orderhistory_market: `Thị trường`,
		orders_ordersrecord_orderhistory_side: `Bên`,
		orders_ordersrecord_orderhistory_price: `Giá bán`,
		orders_ordersrecord_orderhistory_amount: `Số tiền`,
		orders_ordersrecord_orderhistory_total: `Toàn bộ`,
		orders_ordersrecord_orderhistory_filled: `Đã điền%`,
		orders_ordersrecord_orderhistory_action: `Hoạt động`,
		orders_ordersrecord_deals: `Ưu đãi`,
		orders_ordersrecord_deals_time: `Thời gian`,
		orders_ordersrecord_deals_market: `Thị trường`,
		orders_ordersrecord_deals_side: `Bên`,
		orders_ordersrecord_deals_price: `Giá bán`,
		orders_ordersrecord_deals_amount: `Số tiền`,
		orders_ordersrecord_deals_total: `Toàn bộ`,
		orders_ordersrecord_deals_filled: `Đã điền%`,
		orders_ordersrecord_deals_action: `Hoạt động`,
		nav_trade: `Buôn bán`,
		nav_balance: `Thăng bằng`,
		nav_orders: `Đơn đặt hàng`,
		nav_faq: `Câu hỏi thường gặp`,
		nav_fiat: `Fiat`,
		nav_explorer: `nhà thám hiểm`,
		nav_country_virginia: `Virginia`,
		nav_country_singapore: `Singapore`,
		nav_language_english: `Anh`,
		nav_create: `Tạo nên`,
		nav_create_username: `tên tài khoản`,
		nav_create_password: `Mật khẩu`,
		nav_create_repeatpassword: `Lặp lại mật khẩu`,
		nav_create_confirm: `XÁC NHẬN`,
		nav_create_back: `Trở lại`,
		nav_or: `HOẶC LÀ`,
		nav_import: `Nhập khẩu`,
		nav_import_bymnemonics: `Bằng cách ghi nhớ`,
		nav_import_typeyourmnemonics: `Nhập mnemonics của bạn`,
		nav_import_entermnemonics: `Nhập ký ức`,
		nav_import_password: `Mật khẩu`,
		nav_import_enterpassword: `Nhập mật khẩu`,
		nav_import_repeatpassword: `lặp lại mật khẩu`,
		nav_import_reenterpassword: `Nhập lại mật khẩu`,
		nav_import_byprivatekey: `Bằng khóa riêng`,
		nav_import_typeyourprivatekey: `Nhập khóa riêng của bạn`,
		nav_import_enterprivatekey: `Nhập khóa riêng`,
		nav_import_confirm: `XÁC NHẬN`,
		nav_import_createaccount: `tạo tài khoản`,
		nav_import_back: `Trở lại`,
		account_copy: `Sao chép`,
		account_view: `Lượt xem`,
		account_export: `Xuất khẩu`,
		account_export_verifypassword: `Xác nhận lại mật khẩu`,
		account_export_entersomething: `Nhập một cái gì đó`,
		account_export_confirm: `XÁC NHẬN`,
		account_switchaccount: `Chuyển tài khoản`,
		account_createnewaccount: `Tạo tài khoản mới`,
		account_importaccount: `Nhập tài khoản`,
		account_createasset: `Tạo tài sản`,
		account_createmarket: `Tạo thị trường`,
		account_what_is_mnomenics: `Mnomenics là gì?`,
		footer_ecology: `Sinh thái học`,
		footer_ecology_bytetradeblockchain: `Bytetrade Blockchain`,
		footer_ecology_downloadclients: `Tải xuống khách hàng`,
		footer_ecology_pitiopaymentprotocal: `Bảo vệ thanh toán PITIO`,
		footer_support: `Ủng hộ`,
		footer_support_createaccount: `Tạo tài khoản`,
		footer_support_deposit: `Tiền gửi`,
		footer_support_withdraw: `Rút tiền`,
		footer_support_fees: `Lệ phí`,
		footer_support_fee: `Học phí`,
		footer_support_more: `Hơn`,
		footer_contact: `Tiếp xúc`,
		footer_contact_listtoken: `ListToken`,
		footer_socialmedia: `Truyền thông xã hội`,
		footer_mediakit_telegram: `Điện báo`,
		footer_mediakit_facebook: `Facebook`,
		footer_mediakit_twitter: `Twitter`,
		footer_mediakit_medium: `Trung bình`,
		trade_high: `Cao`,
		trade_low: `Thấp`,
		trade_volume: `Âm lượng`,
		trade_change: `Thay đổi`,
		trade_turnover: `Doanh số`,
		trade_coin_name: `Đồng tiền`,
		trade_set_price_field_to_current_highest_ask: `Đặt trường giá thành yêu cầu thấp nhất hiện tại`,
		trade_set_price_field_to_current_highest_bid: `Đặt trường giá thành giá thầu cao nhất hiện tại`,
		trade_set_price_field_to_current_low_ask: `Đặt trường giá thành yêu cầu thấp nhất hiện tại`,
		trade_set_price_field_to_current_low_bid: `Đặt trường giá thành giá thầu thấp nhất hiện tại`,
		trade_chart: `Đồ thị`,
		trade_order_submitted: `Đã gửi đơn hàng`,
		trade_amount_can_not_be_empty: `số lượng không thể để trống`,
		trade_input_is_invaild: `đầu vào là invaild`,
		trade_the_balance_is_not_enough: `Có sẵn là không đủ`,
		trade_next: `Kế tiếp`,
		trade_prev: `Trước đó`,
		trade_no_record: `Không có hồ sơ`,
		trade_amount_is_too_small: `Số tiền quá nhỏ`,
		trade_market_price_error: `Đệ trình thất bại, vì không có giá trên thị trường.`,
		trade_market_price: `Giá thị trường`,
		account_only_3_steps_it_won_t_take_much_longer: `Chỉ 3 bước, sẽ không mất nhiều thời gian hơn`,
		acccount_important: `Quan trọng`,
		account_back_your_account: `Quay lại tài khoản của bạn`,
		account_do_not_forge: `ĐỪNG QUÊN`,
		account_to_save_your_mnomenics_you_will_need_this: `để cứu mnomenics của bạn. Bạn sẽ cần điều này`,
		account_confirm_mnemonic: `Xác nhận ghi nhớ`,
		account_fill_in_the_blanks_to_ensure_the_backup_is_correct: `Điền vào chỗ trống để đảm bảo sao lưu chính xác`,
		account_user_name_is_invaild: `Tên người dùng là invaild`,
		account_password_not_satisfied: `mật khẩu không khớp`,
		account_i_have_read_this_warning: `Tôi đã đọc cảnh báo này`,
		account_byteTrade_is_a_decentralized_system: ` là một hệ thống phi tập trung. Nếu bạn mất thông tin tài khoản từ máy tính này, chúng tôi xin lỗi vì chúng tôi không thể truy xuất được.`,
		account_do_it_later: `Làm sau`,
		account_please_agree_the_anouncement_below: `Vui lòng đồng ý thông báo dưới đây`,
		//nottrans: ``,
		account_welcome_back: `Chào mừng trở lại`,
		account_by_mnemonics: `Bằng cách ghi nhớ`,
		account_by_private_key: `Bằng khóa riêng`,
		account_type_your: `Nhập của bạn`,
		account_type_mnemonics: `ghi nhớ`,
		account_enter: `Đi vào`,
		account_enter_password: `Nhập mật khẩu...`,
		account_repeat_password: `lặp lại mật khẩu`,
		account_re_enter_password: `Nhập lại mật khẩu...`,
		account_or: `HOẶC LÀ`,
		account_crete_account: `Tài khoản Bêlarut`,
		account_private_key: `Khóa riêng`,
		account_mnomenics_error: `Lỗi Mnomenics`,
		account_mnemonics_cannot_be_empty: `ghi nhớ không thể để trống`,
		account_password_cannot_be_empty: `Mật khẩu không được để trống`,
		account_password_unsame: `mật khẩu không bằng mật khẩu reepat`,
		account_username_is_already_exist: `tên người dùng đã tồn tại`,
		account_input_the_password: `nhập mật khẩu`,
		account_mnomenics_was_incorrect: `Mnomenics không chính xác`,
		account_password_wrong: `Mật khẩu sai`,
		account_username_not_exist: `Tên tài khoản này không xuất hiện trên blockchain của chúng tôi`,
		account_mnemonics_length_error: `lỗi chiều dài ghi nhớ`,
		account_username_already_exist: `Tên người dùng đã tồn tại`,
		account_username_invaild: `tên người dùng`,
		account_password_error: `lỗi mật khẩu`,
		account_fail_transfer: `chuyển không thành công`,
		balance_estimated_value: `Giá trị ước tính`,
		balance_input_your_message: `Nhập tin nhắn của bạn ở đây`,
		balance_deposit_address: `Địa chỉ ký gửi`,
		balance_scan_this_qr_code: `Quét mã QR này`,
		balance_please_go_to: `Xin hãy đến`,
		balance_view_Progress: `xem tiến độ`,
		balance_do_not_deposit_any_non_eth_assets_to_this_address: `Không gửi bất kỳ tài sản không {tài sản} nào vào địa chỉ này`,
		balance_min_deposit_amount: `Số tiền gửi tối thiểu`,
		balance_min_withdraw_amount: `Số tiền rút tối thiểu`,
		balance_be_sure_to_check_the_security: `Hãy chắc chắn kiểm tra bảo mật của máy tính và trình duyệt của bạn để ngăn chặn thông tin bị giả mạo hoặc rò rỉ`,
		balance_successful_transfer: `chuyển nhượng thành công`,
		balance_please_input_valid_address: `Vui lòng nhập địa chỉ {property} hợp lệ`,
		order_no_more: `không còn nữa`,
		order_this_is_last_page: `đây là trang cuối`,
		history_process_time: `Tiến trình thời gian`,
		history_transaction: `Giao dịch`,
		mainpage_banner_tatle: `Nền tảng giao dịch tiền điện tử chuyên nghiệp, an toàn và minh bạch`,
		mainpage_advantage_title: `Sàn giao dịch phi tập trung tiền điện tử hàng đầu thế giới`,
		mainpage_advantage_subtitle: `Cung cấp dịch vụ giao dịch tài sản an toàn, ổn định và hiệu quả cho các nhà đầu tư tiền điện tử chuyên nghiệp toàn cầu`,
		mainpage_advantage_assetsecurity: `Bảo mật tài sản chuỗi chéo`,
		mainpage_advantage_assetsecurity_details: `Tài sản của bạn được khóa an toàn vào các hợp đồng thông minh yêu cầu nhiều chữ số trên tất cả các siêu nút để hoàn thành giao dịch.`,
		mainpage_advantage_assetsecurity_details_1: `100% phi tập trung để chỉ bạn có quyền truy cập vào tài sản của mình bằng khóa riêng của bạn.`,
		mainpage_advantage_tradingspeed: `Tốc độ giao dịch nhanh`,
		mainpage_advantage_tradingspeed_details: `Cơ chế đồng thuận blockchain tiên tiến của chúng tôi đạt được hiệu suất và bảo mật vượt trội trong khi hoàn thành các đơn đặt hàng trong vòng 3 giây. Các tính năng có giá trị cho tất cả các thương nhân và nhà đầu tư.`,
		mainpage_advantage_crosschain: `Cơ chế xuyên chuỗi hoàn hảo`,
		mainpage_advantage_crosschain_details: `Giải pháp xuyên chuỗi thực sự duy nhất trong hệ thống giao dịch phi tập trung.`,
		mainpage_advantage_crosschain_details_1: `Chúng tôi hỗ trợ BTC、USDT(ERC20)、ETH 、CMT và các tài sản blockchain chính thống khác. Chúng tôi tiếp tục xây dựng phạm vi giao dịch của bạn.`,
		mainpage_advantage_globalarrangement: `Sắp xếp toàn cầu`,
		mainpage_advantage_globalarrangement_details: `Để đảm bảo trải nghiệm giao dịch cuối cùng cho tất cả người dùng trên toàn thế giới, các siêu nút được triển khai tại 8 quốc gia trên 4 châu lục.`,
		mainpage_advantage_kline: `Công cụ chỉ báo K-line chuyên nghiệp`,
		mainpage_advantage_kline_details: `Hỗ trợ khách hàng chuyên nghiệp của chúng tôi luôn sẵn sàng 24/7.`,
		mainpage_latest_price: `Giá mới nhất`,
		mainpage_change: `Thay đổi`,
		c1: `Tokyo`,
		c2: `Virginia`,
		c3: `London`,
		c4: `Singapore`,
		c5: `Sydney`,
		c6: `sao Paulo`,
		c7: `California`,
		c8: `Seoul`,
		c9: `Frankfurt`,
		c10: `Ohio`,
		c11: `Oregon`,
		p1: `Tokyo`,
		p2: `Virginia`,
		p3: `London`,
		p4: `Singapore`,
		p5: `Sydney`,
		p6: `sao Paulo`,
		p7: `California`,
		p8: `Seoul`,
		p9: `Frankfurt`,
		p10: `Ohio`,
		p11: `Oregon`,
		en: `Anh`,
		password: `Mật khẩu`,
		confirmpw: `Xác nhận mật khẩu`,
		signup: `ĐĂNG KÝ`,
		alreadysu: `Đăng ký?`,
		login: `ĐĂNG NHẬP`,
		signuptitle: `CHÀO MỪNG BẠN ĐẾN GATEWAYSTAR`,
		email: `E-mail`,
		signupwelcome: `CHÀO MỪNG BẠN ĐẾN GATEWAYSTAR`,
		confirm: `XÁC NHẬN`,
		forgetpw: `Quên mật khẩu của bạn`,
		passwordWrong: `Mật khẩu ít nhất 8 ký tự và chứa các chữ cái và số tiếng Anh`,
		emailWrong: `địa chỉ email không hợp lệ`,
		loginWrong: `Sai emal hoặc mật khẩu`,
		userExits: `Email đã thoát`,
		passwordIsSame: `Những mật khẩu không khớp`,
		pleaseInputRightEmail: `Vui lòng nhập đúng email`,
		success: `Sự thành công`,
		invalid_referrer_info: `Thông tin giới thiệu không hợp lệ`,
		invalid_referrer_info_desc: `Tài khoản giới thiệu này không được chấp nhận, vui lòng đảm bảo liên kết giới thiệu là chính xác hoặc đầy đủ. Nhấp vào "Tiếp tục tạo" sẽ không sử dụng thông tin giới thiệu để hoàn tất việc tạo tài khoản. Bạn có chắc chắn để tiếp tục?`,
		invalid_referrer_info_cancel: `Hủy bỏ`,
		invalid_referrer_info_create: `Tiếp tục tạo`,
		input_the_type_and_account_name: `Nhập {loại} và tên tài khoản, cách nhau bằng dấu cách`,
        kyc_function_name: 'KYC',
        kyc_step1_title: 'Bước 1',
        kyc_step1_subtitle: 'Xác minh thông tin',
        kyc_step2_title: 'Bước 2',
        kyc_step2_subtitle: 'Tải lên hình ảnh nhận dạng',
        kyc_step1_field1_title: 'Xác nhận số điện thoại',
        kyc_step1_field1_content1: 'Nhập số điện thoại của bạn',
        kyc_step1_field1_content2: '6 mã kỹ thuật số',
        kyc_step1_field1_content3: 'Gửi mã SMS',
        kyc_step1_field1_content4: 'Gửi lại',
        kyc_step1_field2_title: 'xác nhận địa chỉ email',
        kyc_step1_field2_content1: 'Nhập địa chỉ email của bạn',
        kyc_step1_field2_content2: '6 mã kỹ thuật số',
        kyc_step1_field2_content3: 'Gửi email',
        kyc_step1_field2_content4: 'Gửi lại',
        kyc_step1_confirm_button: 'XÁC NHẬN',
        kyc_step2_field1_title: 'Tên đầu tiên',
        kyc_step2_field1_content: 'Tên đầu tiên',
        kyc_step2_field2_title: 'Họ',
        kyc_step2_field2_content: 'Họ',
        kyc_step2_field3_title: 'Loại danh tính',
        kyc_step2_field3_content1: 'Thẻ chứng minh nhân dân',
        kyc_step2_field3_content2: 'Hộ chiếu',
        kyc_step2_field3_content3: 'Bằng lái xe',
        kyc_step2_field4_title: 'số văn bản',
        kyc_step2_field4_content: 'Nhập số định danh',
        kyc_step2_field5_title: 'Tải lên tài liệu nhận dạng',
        kyc_step2_field5_subtitle: '* Hãy chắc chắn rằng hình ảnh và văn bản rõ ràng, nếu không nó có thể ảnh hưởng đến việc xem xét',
        kyc_step2_field5_content1: 'Nhấn vào đây để tải lên hình ảnh phía trước của tài liệu',
        kyc_step2_field5_content2: 'Nhấn vào đây để tải lên hình ảnh phía sau của tài liệu',
        kyc_step2_field5_content3: 'Nhấn vào đây để tải lên một bức ảnh tự sướng giữ mặt trước của tài liệu nhận dạng',
        kyc_step2_field5_content4_1: 'Nhấp để tải lên bằng chứng hợp lệ về địa chỉ ít hơn 3 tháng tuổi',
        kyc_step2_field5_content4_2: 'a. Hóa đơn tiện ích (Điện, Gas, Nước, v.v.); \n b. Hóa đơn điện thoại cố định; \n c. Thẻ tín dụng hoặc sao kê ngân hàng',
        kyc_status_processing: 'Thông tin ID của bạn đang được xem xét',
        kyc_status_succeed: 'Thông tin ID của bạn đã được xác minh.',
        kyc_status_fail: 'Xác minh danh tính của bạn đã thất bại',
        kyc_status_content1: 'Tài liệu số.',
        kyc_status_content2: 'Lý do',
    },
};



// WEBPACK FOOTER //
// ./src/i18n.js